import { jsx as m, jsxs as M } from "react/jsx-runtime";
import { createContext as xt, useRef as _t, useLayoutEffect as To, useEffect as ze, useContext as j, useId as So, useCallback as qs, useMemo as te, Fragment as Ns, createElement as bo, useInsertionEffect as Po, forwardRef as Mo, Component as Vo } from "react";
const l1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 573.81",
    ...t,
    children: /* @__PURE__ */ m("polygon", { points: "962.19 0 512 450.19 61.81 0 0 61.81 512 573.81 1024 61.81 962.19 0" })
  }
), c1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.84 17.56",
    height: "100%",
    width: "100%",
    ...t,
    children: /* @__PURE__ */ m("polygon", { points: "9.84 1.06 8.78 0 0 8.78 8.78 17.56 9.84 16.5 2.12 8.78 9.84 1.06" })
  }
), u1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.84 17.56",
    height: "100%",
    width: "100%",
    ...t,
    children: /* @__PURE__ */ m("polygon", { points: "1.06 0 0 1.06 7.72 8.78 0 16.5 1.06 17.56 9.84 8.78 1.06 0" })
  }
), h1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 1024 573.8",
    ...t,
    children: /* @__PURE__ */ m("polygon", { points: "61.8 573.8 512 123.6 962.2 573.8 1024 512 512 0 0 512 61.8 573.8" })
  }
), zs = xt({});
function Ao(t) {
  const e = _t(null);
  return e.current === null && (e.current = t()), e.current;
}
const He = typeof window < "u", Co = He ? To : ze, Ue = /* @__PURE__ */ xt(null);
function _e(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function We(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const Z = (t, e, n) => n > e ? e : n < t ? t : n;
function we(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let Tt = () => {
}, Y = () => {
};
process.env.NODE_ENV !== "production" && (Tt = (t, e, n) => {
  !t && typeof console < "u" && console.warn(we(e, n));
}, Y = (t, e, n) => {
  if (!t)
    throw new Error(we(e, n));
});
const X = {}, Hs = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function Us(t) {
  return typeof t == "object" && t !== null;
}
const _s = (t) => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function Ke(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const _ = /* @__NO_SIDE_EFFECTS__ */ (t) => t, Do = (t, e) => (n) => e(t(n)), Ot = (...t) => t.reduce(Do), Rt = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
};
class $e {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return _e(this.subscriptions, e), () => We(this.subscriptions, e);
  }
  notify(e, n, s) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let r = 0; r < i; r++) {
          const o = this.subscriptions[r];
          o && o(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const K = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, $ = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function Ws(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Pn = /* @__PURE__ */ new Set();
function Ge(t, e, n) {
  t || Pn.has(e) || (console.warn(we(e, n)), Pn.add(e));
}
const Ks = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, Eo = 1e-7, Ro = 12;
function Lo(t, e, n, s, i) {
  let r, o, a = 0;
  do
    o = e + (n - e) / 2, r = Ks(o, s, i) - t, r > 0 ? n = o : e = o;
  while (Math.abs(r) > Eo && ++a < Ro);
  return o;
}
function jt(t, e, n, s) {
  if (t === e && n === s)
    return _;
  const i = (r) => Lo(r, 0, 1, t, n);
  return (r) => r === 0 || r === 1 ? r : Ks(i(r), e, s);
}
const $s = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Gs = (t) => (e) => 1 - t(1 - e), Zs = /* @__PURE__ */ jt(0.33, 1.53, 0.69, 0.99), Ze = /* @__PURE__ */ Gs(Zs), Ys = /* @__PURE__ */ $s(Ze), Xs = (t) => (t *= 2) < 1 ? 0.5 * Ze(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Ye = (t) => 1 - Math.sin(Math.acos(t)), Js = Gs(Ye), Qs = $s(Ye), Bo = /* @__PURE__ */ jt(0.42, 0, 1, 1), ko = /* @__PURE__ */ jt(0, 0, 0.58, 1), ti = /* @__PURE__ */ jt(0.42, 0, 0.58, 1), Io = (t) => Array.isArray(t) && typeof t[0] != "number", ei = (t) => Array.isArray(t) && typeof t[0] == "number", Mn = {
  linear: _,
  easeIn: Bo,
  easeInOut: ti,
  easeOut: ko,
  circIn: Ye,
  circInOut: Qs,
  circOut: Js,
  backIn: Ze,
  backInOut: Ys,
  backOut: Zs,
  anticipate: Xs
}, Fo = (t) => typeof t == "string", Vn = (t) => {
  if (ei(t)) {
    Y(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, s, i] = t;
    return jt(e, n, s, i);
  } else if (Fo(t))
    return Y(Mn[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), Mn[t];
  return t;
}, zt = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], An = {
  value: null,
  addProjectionMetrics: null
};
function Oo(t, e) {
  let n = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), i = !1, r = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = 0;
  function u(h) {
    o.has(h) && (c.schedule(h), t()), l++, h(a);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (h, f = !1, d = !1) => {
      const y = d && i ? n : s;
      return f && o.add(h), y.has(h) || y.add(h), h;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (h) => {
      s.delete(h), o.delete(h);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (h) => {
      if (a = h, i) {
        r = !0;
        return;
      }
      i = !0, [n, s] = [s, n], n.forEach(u), e && An.value && An.value.frameloop[e].push(l), l = 0, n.clear(), i = !1, r && (r = !1, c.process(h));
    }
  };
  return c;
}
const jo = 40;
function ni(t, e) {
  let n = !1, s = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, r = () => n = !0, o = zt.reduce((v, P) => (v[P] = Oo(r, e ? P : void 0), v), {}), { setup: a, read: l, resolveKeyframes: u, preUpdate: c, update: h, preRender: f, render: d, postRender: p } = o, y = () => {
    const v = X.useManualTiming ? i.timestamp : performance.now();
    n = !1, X.useManualTiming || (i.delta = s ? 1e3 / 60 : Math.max(Math.min(v - i.timestamp, jo), 1)), i.timestamp = v, i.isProcessing = !0, a.process(i), l.process(i), u.process(i), c.process(i), h.process(i), f.process(i), d.process(i), p.process(i), i.isProcessing = !1, n && e && (s = !1, t(y));
  }, w = () => {
    n = !0, s = !0, i.isProcessing || t(y);
  };
  return { schedule: zt.reduce((v, P) => {
    const S = o[P];
    return v[P] = (V, L = !1, b = !1) => (n || w(), S.schedule(V, L, b)), v;
  }, {}), cancel: (v) => {
    for (let P = 0; P < zt.length; P++)
      o[zt[P]].cancel(v);
  }, state: i, steps: o };
}
const { schedule: A, cancel: Q, state: k, steps: ie } = /* @__PURE__ */ ni(typeof requestAnimationFrame < "u" ? requestAnimationFrame : _, !0);
let Wt;
function qo() {
  Wt = void 0;
}
const q = {
  now: () => (Wt === void 0 && q.set(k.isProcessing || X.useManualTiming ? k.timestamp : performance.now()), Wt),
  set: (t) => {
    Wt = t, queueMicrotask(qo);
  }
}, si = (t) => (e) => typeof e == "string" && e.startsWith(t), Xe = /* @__PURE__ */ si("--"), No = /* @__PURE__ */ si("var(--"), Je = (t) => No(t) ? zo.test(t.split("/*")[0].trim()) : !1, zo = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, St = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Lt = {
  ...St,
  transform: (t) => Z(0, 1, t)
}, Ht = {
  ...St,
  default: 1
}, At = (t) => Math.round(t * 1e5) / 1e5, Qe = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Ho(t) {
  return t == null;
}
const Uo = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, tn = (t, e) => (n) => !!(typeof n == "string" && Uo.test(n) && n.startsWith(t) || e && !Ho(n) && Object.prototype.hasOwnProperty.call(n, e)), ii = (t, e, n) => (s) => {
  if (typeof s != "string")
    return s;
  const [i, r, o, a] = s.match(Qe);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(r),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, _o = (t) => Z(0, 255, t), oe = {
  ...St,
  transform: (t) => Math.round(_o(t))
}, ot = {
  test: /* @__PURE__ */ tn("rgb", "red"),
  parse: /* @__PURE__ */ ii("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + oe.transform(t) + ", " + oe.transform(e) + ", " + oe.transform(n) + ", " + At(Lt.transform(s)) + ")"
};
function Wo(t) {
  let e = "", n = "", s = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, s += s, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const xe = {
  test: /* @__PURE__ */ tn("#"),
  parse: Wo,
  transform: ot.transform
}, qt = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), J = /* @__PURE__ */ qt("deg"), G = /* @__PURE__ */ qt("%"), T = /* @__PURE__ */ qt("px"), Ko = /* @__PURE__ */ qt("vh"), $o = /* @__PURE__ */ qt("vw"), Cn = /* @__PURE__ */ (() => ({
  ...G,
  parse: (t) => G.parse(t) / 100,
  transform: (t) => G.transform(t * 100)
}))(), ht = {
  test: /* @__PURE__ */ tn("hsl", "hue"),
  parse: /* @__PURE__ */ ii("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + G.transform(At(e)) + ", " + G.transform(At(n)) + ", " + At(Lt.transform(s)) + ")"
}, R = {
  test: (t) => ot.test(t) || xe.test(t) || ht.test(t),
  parse: (t) => ot.test(t) ? ot.parse(t) : ht.test(t) ? ht.parse(t) : xe.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? ot.transform(t) : ht.transform(t),
  getAnimatableNone: (t) => {
    const e = R.parse(t);
    return e.alpha = 0, R.transform(e);
  }
}, Go = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Zo(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(Qe)) == null ? void 0 : e.length) || 0) + (((n = t.match(Go)) == null ? void 0 : n.length) || 0) > 0;
}
const oi = "number", ri = "color", Yo = "var", Xo = "var(", Dn = "${}", Jo = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Bt(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let r = 0;
  const a = e.replace(Jo, (l) => (R.test(l) ? (s.color.push(r), i.push(ri), n.push(R.parse(l))) : l.startsWith(Xo) ? (s.var.push(r), i.push(Yo), n.push(l)) : (s.number.push(r), i.push(oi), n.push(parseFloat(l))), ++r, Dn)).split(Dn);
  return { values: n, split: a, indexes: s, types: i };
}
function ai(t) {
  return Bt(t).values;
}
function li(t) {
  const { split: e, types: n } = Bt(t), s = e.length;
  return (i) => {
    let r = "";
    for (let o = 0; o < s; o++)
      if (r += e[o], i[o] !== void 0) {
        const a = n[o];
        a === oi ? r += At(i[o]) : a === ri ? r += R.transform(i[o]) : r += i[o];
      }
    return r;
  };
}
const Qo = (t) => typeof t == "number" ? 0 : R.test(t) ? R.getAnimatableNone(t) : t;
function tr(t) {
  const e = ai(t);
  return li(t)(e.map(Qo));
}
const tt = {
  test: Zo,
  parse: ai,
  createTransformer: li,
  getAnimatableNone: tr
};
function re(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function er({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, r = 0, o = 0;
  if (!e)
    i = r = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    i = re(l, a, t + 1 / 3), r = re(l, a, t), o = re(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(r * 255),
    blue: Math.round(o * 255),
    alpha: s
  };
}
function Zt(t, e) {
  return (n) => n > 0 ? e : t;
}
const D = (t, e, n) => t + (e - t) * n, ae = (t, e, n) => {
  const s = t * t, i = n * (e * e - s) + s;
  return i < 0 ? 0 : Math.sqrt(i);
}, nr = [xe, ot, ht], sr = (t) => nr.find((e) => e.test(t));
function En(t) {
  const e = sr(t);
  if (Tt(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === ht && (n = er(n)), n;
}
const Rn = (t, e) => {
  const n = En(t), s = En(e);
  if (!n || !s)
    return Zt(t, e);
  const i = { ...n };
  return (r) => (i.red = ae(n.red, s.red, r), i.green = ae(n.green, s.green, r), i.blue = ae(n.blue, s.blue, r), i.alpha = D(n.alpha, s.alpha, r), ot.transform(i));
}, Te = /* @__PURE__ */ new Set(["none", "hidden"]);
function ir(t, e) {
  return Te.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function or(t, e) {
  return (n) => D(t, e, n);
}
function en(t) {
  return typeof t == "number" ? or : typeof t == "string" ? Je(t) ? Zt : R.test(t) ? Rn : lr : Array.isArray(t) ? ci : typeof t == "object" ? R.test(t) ? Rn : rr : Zt;
}
function ci(t, e) {
  const n = [...t], s = n.length, i = t.map((r, o) => en(r)(r, e[o]));
  return (r) => {
    for (let o = 0; o < s; o++)
      n[o] = i[o](r);
    return n;
  };
}
function rr(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (s[i] = en(t[i])(t[i], e[i]));
  return (i) => {
    for (const r in s)
      n[r] = s[r](i);
    return n;
  };
}
function ar(t, e) {
  const n = [], s = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const r = e.types[i], o = t.indexes[r][s[r]], a = t.values[o] ?? 0;
    n[i] = a, s[r]++;
  }
  return n;
}
const lr = (t, e) => {
  const n = tt.createTransformer(e), s = Bt(t), i = Bt(e);
  return s.indexes.var.length === i.indexes.var.length && s.indexes.color.length === i.indexes.color.length && s.indexes.number.length >= i.indexes.number.length ? Te.has(t) && !i.values.length || Te.has(e) && !s.values.length ? ir(t, e) : Ot(ci(ar(s, i), i.values), n) : (Tt(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Zt(t, e));
};
function ui(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? D(t, e, n) : en(t)(t, e);
}
const cr = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => A.update(e, n),
    stop: () => Q(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => k.isProcessing ? k.timestamp : q.now()
  };
}, hi = (t, e, n = 10) => {
  let s = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let r = 0; r < i; r++)
    s += Math.round(t(r / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${s.substring(0, s.length - 2)})`;
}, Yt = 2e4;
function nn(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < Yt; )
    e += n, s = t.next(e);
  return e >= Yt ? 1 / 0 : e;
}
function ur(t, e = 100, n) {
  const s = n({ ...t, keyframes: [0, e] }), i = Math.min(nn(s), Yt);
  return {
    type: "keyframes",
    ease: (r) => s.next(i * r).value / e,
    duration: /* @__PURE__ */ $(i)
  };
}
const hr = 5;
function fi(t, e, n) {
  const s = Math.max(e - hr, 0);
  return Ws(n - t(s), e - s);
}
const C = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, le = 1e-3;
function fr({ duration: t = C.duration, bounce: e = C.bounce, velocity: n = C.velocity, mass: s = C.mass }) {
  let i, r;
  Tt(t <= /* @__PURE__ */ K(C.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = Z(C.minDamping, C.maxDamping, o), t = Z(C.minDuration, C.maxDuration, /* @__PURE__ */ $(t)), o < 1 ? (i = (u) => {
    const c = u * o, h = c * t, f = c - n, d = Se(u, o), p = Math.exp(-h);
    return le - f / d * p;
  }, r = (u) => {
    const h = u * o * t, f = h * n + n, d = Math.pow(o, 2) * Math.pow(u, 2) * t, p = Math.exp(-h), y = Se(Math.pow(u, 2), o);
    return (-i(u) + le > 0 ? -1 : 1) * ((f - d) * p) / y;
  }) : (i = (u) => {
    const c = Math.exp(-u * t), h = (u - n) * t + 1;
    return -le + c * h;
  }, r = (u) => {
    const c = Math.exp(-u * t), h = (n - u) * (t * t);
    return c * h;
  });
  const a = 5 / t, l = mr(i, r, a);
  if (t = /* @__PURE__ */ K(t), isNaN(l))
    return {
      stiffness: C.stiffness,
      damping: C.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * s;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(s * u),
      duration: t
    };
  }
}
const dr = 12;
function mr(t, e, n) {
  let s = n;
  for (let i = 1; i < dr; i++)
    s = s - t(s) / e(s);
  return s;
}
function Se(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const pr = ["duration", "bounce"], gr = ["stiffness", "damping", "mass"];
function Ln(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function yr(t) {
  let e = {
    velocity: C.velocity,
    stiffness: C.stiffness,
    damping: C.damping,
    mass: C.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Ln(t, gr) && Ln(t, pr))
    if (t.visualDuration) {
      const n = t.visualDuration, s = 2 * Math.PI / (n * 1.2), i = s * s, r = 2 * Z(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: C.mass,
        stiffness: i,
        damping: r
      };
    } else {
      const n = fr(t);
      e = {
        ...e,
        ...n,
        mass: C.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Xt(t = C.visualDuration, e = C.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: s, restDelta: i } = n;
  const r = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: r }, { stiffness: l, damping: u, mass: c, duration: h, velocity: f, isResolvedFromDuration: d } = yr({
    ...n,
    velocity: -/* @__PURE__ */ $(n.velocity || 0)
  }), p = f || 0, y = u / (2 * Math.sqrt(l * c)), w = o - r, g = /* @__PURE__ */ $(Math.sqrt(l / c)), x = Math.abs(w) < 5;
  s || (s = x ? C.restSpeed.granular : C.restSpeed.default), i || (i = x ? C.restDelta.granular : C.restDelta.default);
  let v;
  if (y < 1) {
    const S = Se(g, y);
    v = (V) => {
      const L = Math.exp(-y * g * V);
      return o - L * ((p + y * g * w) / S * Math.sin(S * V) + w * Math.cos(S * V));
    };
  } else if (y === 1)
    v = (S) => o - Math.exp(-g * S) * (w + (p + g * w) * S);
  else {
    const S = g * Math.sqrt(y * y - 1);
    v = (V) => {
      const L = Math.exp(-y * g * V), b = Math.min(S * V, 300);
      return o - L * ((p + y * g * w) * Math.sinh(b) + S * w * Math.cosh(b)) / S;
    };
  }
  const P = {
    calculatedDuration: d && h || null,
    next: (S) => {
      const V = v(S);
      if (d)
        a.done = S >= h;
      else {
        let L = S === 0 ? p : 0;
        y < 1 && (L = S === 0 ? /* @__PURE__ */ K(p) : fi(v, S, V));
        const b = Math.abs(L) <= s, O = Math.abs(o - V) <= i;
        a.done = b && O;
      }
      return a.value = a.done ? o : V, a;
    },
    toString: () => {
      const S = Math.min(nn(P), Yt), V = hi((L) => P.next(S * L).value, S, 30);
      return S + "ms " + V;
    },
    toTransition: () => {
    }
  };
  return P;
}
Xt.applyToOptions = (t) => {
  const e = ur(t, 100, Xt);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ K(e.duration), t.type = "keyframes", t;
};
function be({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: i = 10, bounceStiffness: r = 500, modifyTarget: o, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const h = t[0], f = {
    done: !1,
    value: h
  }, d = (b) => a !== void 0 && b < a || l !== void 0 && b > l, p = (b) => a === void 0 ? l : l === void 0 || Math.abs(a - b) < Math.abs(l - b) ? a : l;
  let y = n * e;
  const w = h + y, g = o === void 0 ? w : o(w);
  g !== w && (y = g - h);
  const x = (b) => -y * Math.exp(-b / s), v = (b) => g + x(b), P = (b) => {
    const O = x(b), N = v(b);
    f.done = Math.abs(O) <= u, f.value = f.done ? g : N;
  };
  let S, V;
  const L = (b) => {
    d(f.value) && (S = b, V = Xt({
      keyframes: [f.value, p(f.value)],
      velocity: fi(v, b, f.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: r,
      restDelta: u,
      restSpeed: c
    }));
  };
  return L(0), {
    calculatedDuration: null,
    next: (b) => {
      let O = !1;
      return !V && S === void 0 && (O = !0, P(b), L(b)), S !== void 0 && b >= S ? V.next(b - S) : (!O && P(b), f);
    }
  };
}
function vr(t, e, n) {
  const s = [], i = n || X.mix || ui, r = t.length - 1;
  for (let o = 0; o < r; o++) {
    let a = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || _ : e;
      a = Ot(l, a);
    }
    s.push(a);
  }
  return s;
}
function wr(t, e, { clamp: n = !0, ease: s, mixer: i } = {}) {
  const r = t.length;
  if (Y(r === e.length, "Both input and output ranges must be the same length", "range-length"), r === 1)
    return () => e[0];
  if (r === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[r - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = vr(e, s, i), l = a.length, u = (c) => {
    if (o && c < t[0])
      return e[0];
    let h = 0;
    if (l > 1)
      for (; h < t.length - 2 && !(c < t[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ Rt(t[h], t[h + 1], c);
    return a[h](f);
  };
  return n ? (c) => u(Z(t[0], t[r - 1], c)) : u;
}
function xr(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const i = /* @__PURE__ */ Rt(0, e, s);
    t.push(D(n, 1, i));
  }
}
function Tr(t) {
  const e = [0];
  return xr(e, t.length - 1), e;
}
function Sr(t, e) {
  return t.map((n) => n * e);
}
function br(t, e) {
  return t.map(() => e || ti).splice(0, t.length - 1);
}
function ft({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const i = Io(s) ? s.map(Vn) : Vn(s), r = {
    done: !1,
    value: e[0]
  }, o = Sr(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : Tr(e),
    t
  ), a = wr(o, e, {
    ease: Array.isArray(i) ? i : br(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (r.value = a(l), r.done = l >= t, r)
  };
}
const Pr = (t) => t !== null;
function sn(t, { repeat: e, repeatType: n = "loop" }, s, i = 1) {
  const r = t.filter(Pr), a = i < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : r.length - 1;
  return !a || s === void 0 ? r[a] : s;
}
const Mr = {
  decay: be,
  inertia: be,
  tween: ft,
  keyframes: ft,
  spring: Xt
};
function di(t) {
  typeof t.type == "string" && (t.type = Mr[t.type]);
}
class on {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const Vr = (t) => t / 100;
class rn extends on {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var s, i;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== q.now() && this.tick(q.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (s = this.options).onStop) == null || i.call(s));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    di(e);
    const { type: n = ft, repeat: s = 0, repeatDelay: i = 0, repeatType: r, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const l = n || ft;
    process.env.NODE_ENV !== "production" && l !== ft && Y(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== ft && typeof a[0] != "number" && (this.mixKeyframes = Ot(Vr, ui(a[0], a[1])), a = [0, 100]);
    const u = l({ ...e, keyframes: a });
    r === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = nn(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (s + 1) - i, this.generator = u;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: s, totalDuration: i, mixKeyframes: r, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return s.next(0);
    const { delay: u = 0, keyframes: c, repeat: h, repeatType: f, repeatDelay: d, type: p, onUpdate: y, finalKeyframe: w } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - i / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), x = this.playbackSpeed >= 0 ? g < 0 : g > i;
    this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let v = this.currentTime, P = s;
    if (h) {
      const b = Math.min(this.currentTime, i) / a;
      let O = Math.floor(b), N = b % 1;
      !N && b >= 1 && (N = 1), N === 1 && O--, O = Math.min(O, h + 1), !!(O % 2) && (f === "reverse" ? (N = 1 - N, d && (N -= d / a)) : f === "mirror" && (P = o)), v = Z(0, 1, N) * a;
    }
    const S = x ? { done: !1, value: c[0] } : P.next(v);
    r && (S.value = r(S.value));
    let { done: V } = S;
    !x && l !== null && (V = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const L = this.holdTime === null && (this.state === "finished" || this.state === "running" && V);
    return L && p !== be && (S.value = sn(c, this.options, w, this.speed)), y && y(S.value), L && this.finish(), S;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ $(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ $(this.currentTime);
  }
  set time(e) {
    var n;
    e = /* @__PURE__ */ K(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(q.now());
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ $(this.currentTime));
  }
  play() {
    var i, r;
    if (this.isStopped)
      return;
    const { driver: e = cr, startTime: n } = this.options;
    this.driver || (this.driver = e((o) => this.tick(o))), (r = (i = this.options).onPlay) == null || r.call(i);
    const s = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = s) : this.holdTime !== null ? this.startTime = s - this.holdTime : this.startTime || (this.startTime = n ?? s), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(q.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (e = this.options).onComplete) == null || n.call(e);
  }
  cancel() {
    var e, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (e = this.options).onCancel) == null || n.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), e.observe(this);
  }
}
function Ar(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const rt = (t) => t * 180 / Math.PI, Pe = (t) => {
  const e = rt(Math.atan2(t[1], t[0]));
  return Me(e);
}, Cr = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: Pe,
  rotateZ: Pe,
  skewX: (t) => rt(Math.atan(t[1])),
  skewY: (t) => rt(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, Me = (t) => (t = t % 360, t < 0 && (t += 360), t), Bn = Pe, kn = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), In = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), Dr = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: kn,
  scaleY: In,
  scale: (t) => (kn(t) + In(t)) / 2,
  rotateX: (t) => Me(rt(Math.atan2(t[6], t[5]))),
  rotateY: (t) => Me(rt(Math.atan2(-t[2], t[0]))),
  rotateZ: Bn,
  rotate: Bn,
  skewX: (t) => rt(Math.atan(t[4])),
  skewY: (t) => rt(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Ve(t) {
  return t.includes("scale") ? 1 : 0;
}
function Ae(t, e) {
  if (!t || t === "none")
    return Ve(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let s, i;
  if (n)
    s = Dr, i = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    s = Cr, i = a;
  }
  if (!i)
    return Ve(e);
  const r = s[e], o = i[1].split(",").map(Rr);
  return typeof r == "function" ? r(o) : o[r];
}
const Er = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return Ae(n, e);
};
function Rr(t) {
  return parseFloat(t.trim());
}
const bt = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Pt = /* @__PURE__ */ (() => new Set(bt))(), Fn = (t) => t === St || t === T, Lr = /* @__PURE__ */ new Set(["x", "y", "z"]), Br = bt.filter((t) => !Lr.has(t));
function kr(t) {
  const e = [];
  return Br.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const at = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => Ae(e, "x"),
  y: (t, { transform: e }) => Ae(e, "y")
};
at.translateX = at.x;
at.translateY = at.y;
const lt = /* @__PURE__ */ new Set();
let Ce = !1, De = !1, Ee = !1;
function mi() {
  if (De) {
    const t = Array.from(lt).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const i = kr(s);
      i.length && (n.set(s, i), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const i = n.get(s);
      i && i.forEach(([r, o]) => {
        var a;
        (a = s.getValue(r)) == null || a.set(o);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  De = !1, Ce = !1, lt.forEach((t) => t.complete(Ee)), lt.clear();
}
function pi() {
  lt.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (De = !0);
  });
}
function Ir() {
  Ee = !0, pi(), mi(), Ee = !1;
}
class an {
  constructor(e, n, s, i, r, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = i, this.element = r, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (lt.add(this), Ce || (Ce = !0, A.read(pi), A.resolveKeyframes(mi))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: i } = this;
    if (e[0] === null) {
      const r = i == null ? void 0 : i.get(), o = e[e.length - 1];
      if (r !== void 0)
        e[0] = r;
      else if (s && n) {
        const a = s.readValue(n, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), i && r === void 0 && i.set(e[0]);
    }
    Ar(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), lt.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (lt.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const Fr = (t) => t.startsWith("--");
function Or(t, e, n) {
  Fr(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const jr = /* @__PURE__ */ Ke(() => window.ScrollTimeline !== void 0), qr = {};
function Nr(t, e) {
  const n = /* @__PURE__ */ Ke(t);
  return () => qr[e] ?? n();
}
const gi = /* @__PURE__ */ Nr(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Vt = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, On = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Vt([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Vt([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Vt([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Vt([0.33, 1.53, 0.69, 0.99])
};
function yi(t, e) {
  if (t)
    return typeof t == "function" ? gi() ? hi(t, e) : "ease-out" : ei(t) ? Vt(t) : Array.isArray(t) ? t.map((n) => yi(n, e) || On.easeOut) : On[t];
}
function zr(t, e, n, { delay: s = 0, duration: i = 300, repeat: r = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [e]: n
  };
  l && (c.offset = l);
  const h = yi(a, i);
  Array.isArray(h) && (c.easing = h);
  const f = {
    delay: s,
    duration: i,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: r + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), t.animate(c, f);
}
function vi(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function Hr({ type: t, ...e }) {
  return vi(t) && gi() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class Ur extends on {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e)
      return;
    const { element: n, name: s, keyframes: i, pseudoElement: r, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!r, this.allowFlatten = o, this.options = e, Y(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = Hr(e);
    this.animation = zr(n, s, i, u, r), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !r) {
        const c = sn(i, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : Or(n, s, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, n;
    (n = (e = this.animation).finish) == null || n.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, n;
    this.isPseudoElement || (n = (e = this.animation).commitStyles) == null || n.call(e);
  }
  get duration() {
    var n, s;
    const e = ((s = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : s.call(n).duration) || 0;
    return /* @__PURE__ */ $(Number(e));
  }
  get time() {
    return /* @__PURE__ */ $(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ K(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: n }) {
    var s;
    return this.allowFlatten && ((s = this.animation.effect) == null || s.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && jr() ? (this.animation.timeline = e, _) : n(this);
  }
}
const wi = {
  anticipate: Xs,
  backInOut: Ys,
  circInOut: Qs
};
function _r(t) {
  return t in wi;
}
function Wr(t) {
  typeof t.ease == "string" && _r(t.ease) && (t.ease = wi[t.ease]);
}
const jn = 10;
class Kr extends Ur {
  constructor(e) {
    Wr(e), di(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: s, onComplete: i, element: r, ...o } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new rn({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ K(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - jn).value, a.sample(l).value, jn), a.stop();
  }
}
const qn = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(tt.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function $r(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function Gr(t, e, n, s) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const r = t[t.length - 1], o = qn(i, e), a = qn(r, e);
  return Tt(o === a, `You are trying to animate ${e} from "${i}" to "${r}". "${o ? r : i}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : $r(t) || (n === "spring" || vi(n)) && s;
}
function Re(t) {
  t.duration = 0, t.type;
}
const Zr = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), Yr = /* @__PURE__ */ Ke(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Xr(t) {
  var c;
  const { motionValue: e, name: n, repeatDelay: s, repeatType: i, damping: r, type: o } = t;
  if (!(((c = e == null ? void 0 : e.owner) == null ? void 0 : c.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: l, transformTemplate: u } = e.owner.getProps();
  return Yr() && n && Zr.has(n) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !l && !s && i !== "mirror" && r !== 0 && o !== "inertia";
}
const Jr = 40;
class Qr extends on {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: i = 0, repeatDelay: r = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: u, element: c, ...h }) {
    var p;
    super(), this.stop = () => {
      var y, w;
      this._animation && (this._animation.stop(), (y = this.stopTimeline) == null || y.call(this)), (w = this.keyframeResolver) == null || w.cancel();
    }, this.createdAt = q.now();
    const f = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: i,
      repeatDelay: r,
      repeatType: o,
      name: l,
      motionValue: u,
      element: c,
      ...h
    }, d = (c == null ? void 0 : c.KeyframeResolver) || an;
    this.keyframeResolver = new d(a, (y, w, g) => this.onKeyframesResolved(y, w, f, !g), l, u, c), (p = this.keyframeResolver) == null || p.scheduleResolve();
  }
  onKeyframesResolved(e, n, s, i) {
    this.keyframeResolver = void 0;
    const { name: r, type: o, velocity: a, delay: l, isHandoff: u, onUpdate: c } = s;
    this.resolvedAt = q.now(), Gr(e, r, o, a) || ((X.instantAnimations || !l) && (c == null || c(sn(e, s, n))), e[0] = e[e.length - 1], Re(s), s.repeat = 0);
    const f = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > Jr ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...s,
      keyframes: e
    }, d = !u && Xr(f) ? new Kr({
      ...f,
      element: f.motionValue.owner.current
    }) : new rn(f);
    d.finished.then(() => this.notifyFinished()).catch(_), this.pendingTimeline && (this.stopTimeline = d.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = d;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), Ir()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
const ta = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function ea(t) {
  const e = ta.exec(t);
  if (!e)
    return [,];
  const [, n, s, i] = e;
  return [`--${n ?? s}`, i];
}
const na = 4;
function xi(t, e, n = 1) {
  Y(n <= na, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [s, i] = ea(t);
  if (!s)
    return;
  const r = window.getComputedStyle(e).getPropertyValue(s);
  if (r) {
    const o = r.trim();
    return Hs(o) ? parseFloat(o) : o;
  }
  return Je(i) ? xi(i, e, n + 1) : i;
}
function ln(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const Ti = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...bt
]), sa = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Si = (t) => (e) => e.test(t), bi = [St, T, G, J, $o, Ko, sa], Nn = (t) => bi.find(Si(t));
function ia(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || _s(t) : !0;
}
const oa = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function ra(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(Qe) || [];
  if (!s)
    return t;
  const i = n.replace(s, "");
  let r = oa.has(e) ? 1 : 0;
  return s !== n && (r *= 100), e + "(" + r + i + ")";
}
const aa = /\b([a-z-]*)\(.*?\)/gu, Le = {
  ...tt,
  getAnimatableNone: (t) => {
    const e = t.match(aa);
    return e ? e.map(ra).join(" ") : t;
  }
}, zn = {
  ...St,
  transform: Math.round
}, la = {
  rotate: J,
  rotateX: J,
  rotateY: J,
  rotateZ: J,
  scale: Ht,
  scaleX: Ht,
  scaleY: Ht,
  scaleZ: Ht,
  skew: J,
  skewX: J,
  skewY: J,
  distance: T,
  translateX: T,
  translateY: T,
  translateZ: T,
  x: T,
  y: T,
  z: T,
  perspective: T,
  transformPerspective: T,
  opacity: Lt,
  originX: Cn,
  originY: Cn,
  originZ: T
}, cn = {
  // Border props
  borderWidth: T,
  borderTopWidth: T,
  borderRightWidth: T,
  borderBottomWidth: T,
  borderLeftWidth: T,
  borderRadius: T,
  radius: T,
  borderTopLeftRadius: T,
  borderTopRightRadius: T,
  borderBottomRightRadius: T,
  borderBottomLeftRadius: T,
  // Positioning props
  width: T,
  maxWidth: T,
  height: T,
  maxHeight: T,
  top: T,
  right: T,
  bottom: T,
  left: T,
  // Spacing props
  padding: T,
  paddingTop: T,
  paddingRight: T,
  paddingBottom: T,
  paddingLeft: T,
  margin: T,
  marginTop: T,
  marginRight: T,
  marginBottom: T,
  marginLeft: T,
  // Misc
  backgroundPositionX: T,
  backgroundPositionY: T,
  ...la,
  zIndex: zn,
  // SVG
  fillOpacity: Lt,
  strokeOpacity: Lt,
  numOctaves: zn
}, ca = {
  ...cn,
  // Color props
  color: R,
  backgroundColor: R,
  outlineColor: R,
  fill: R,
  stroke: R,
  // Border props
  borderColor: R,
  borderTopColor: R,
  borderRightColor: R,
  borderBottomColor: R,
  borderLeftColor: R,
  filter: Le,
  WebkitFilter: Le
}, Pi = (t) => ca[t];
function Mi(t, e) {
  let n = Pi(t);
  return n !== Le && (n = tt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const ua = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function ha(t, e, n) {
  let s = 0, i;
  for (; s < t.length && !i; ) {
    const r = t[s];
    typeof r == "string" && !ua.has(r) && Bt(r).values.length && (i = t[s]), s++;
  }
  if (i && n)
    for (const r of e)
      t[r] = Mi(n, i);
}
class fa extends an {
  constructor(e, n, s, i, r) {
    super(e, n, s, i, r, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: s } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && (u = u.trim(), Je(u))) {
        const c = xi(u, n.current);
        c !== void 0 && (e[l] = c), l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !Ti.has(s) || e.length !== 2)
      return;
    const [i, r] = e, o = Nn(i), a = Nn(r);
    if (o !== a)
      if (Fn(o) && Fn(a))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else
        at[s] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, s = [];
    for (let i = 0; i < e.length; i++)
      (e[i] === null || ia(e[i])) && s.push(i);
    s.length && ha(e, s, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: s } = this;
    if (!e || !e.current)
      return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = at[s](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(s, i).jump(i, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: n, unresolvedKeyframes: s } = this;
    if (!e || !e.current)
      return;
    const i = e.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const r = s.length - 1, o = s[r];
    s[r] = at[n](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, u]) => {
      e.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function da(t, e, n) {
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let s = document;
    e && (s = e.current);
    const i = (n == null ? void 0 : n[t]) ?? s.querySelectorAll(t);
    return i ? Array.from(i) : [];
  }
  return Array.from(t);
}
const Vi = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function ma(t) {
  return Us(t) && "offsetHeight" in t;
}
const Hn = 30, pa = (t) => !isNaN(parseFloat(t));
class ga {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s) => {
      var r;
      const i = q.now();
      if (this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && ((r = this.events.change) == null || r.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = q.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = pa(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Ge(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new $e());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), A.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = q.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Hn)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Hn);
    return Ws(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, n;
    (e = this.dependents) == null || e.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function vt(t, e) {
  return new ga(t, e);
}
const { schedule: un, cancel: f1 } = /* @__PURE__ */ ni(queueMicrotask, !1), W = {
  x: !1,
  y: !1
};
function Ai() {
  return W.x || W.y;
}
function ya(t) {
  return t === "x" || t === "y" ? W[t] ? null : (W[t] = !0, () => {
    W[t] = !1;
  }) : W.x || W.y ? null : (W.x = W.y = !0, () => {
    W.x = W.y = !1;
  });
}
function Ci(t, e) {
  const n = da(t), s = new AbortController(), i = {
    passive: !0,
    ...e,
    signal: s.signal
  };
  return [n, i, () => s.abort()];
}
function Un(t) {
  return !(t.pointerType === "touch" || Ai());
}
function va(t, e, n = {}) {
  const [s, i, r] = Ci(t, n), o = (a) => {
    if (!Un(a))
      return;
    const { target: l } = a, u = e(l, a);
    if (typeof u != "function" || !l)
      return;
    const c = (h) => {
      Un(h) && (u(h), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, i);
  };
  return s.forEach((a) => {
    a.addEventListener("pointerenter", o, i);
  }), r;
}
const Di = (t, e) => e ? t === e ? !0 : Di(t, e.parentElement) : !1, hn = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, wa = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function xa(t) {
  return wa.has(t.tagName) || t.tabIndex !== -1;
}
const Kt = /* @__PURE__ */ new WeakSet();
function _n(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function ce(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const Ta = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const s = _n(() => {
    if (Kt.has(n))
      return;
    ce(n, "down");
    const i = _n(() => {
      ce(n, "up");
    }), r = () => ce(n, "cancel");
    n.addEventListener("keyup", i, e), n.addEventListener("blur", r, e);
  });
  n.addEventListener("keydown", s, e), n.addEventListener("blur", () => n.removeEventListener("keydown", s), e);
};
function Wn(t) {
  return hn(t) && !Ai();
}
function Sa(t, e, n = {}) {
  const [s, i, r] = Ci(t, n), o = (a) => {
    const l = a.currentTarget;
    if (!Wn(a))
      return;
    Kt.add(l);
    const u = e(l, a), c = (d, p) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", f), Kt.has(l) && Kt.delete(l), Wn(d) && typeof u == "function" && u(d, { success: p });
    }, h = (d) => {
      c(d, l === window || l === document || n.useGlobalTarget || Di(l, d.target));
    }, f = (d) => {
      c(d, !1);
    };
    window.addEventListener("pointerup", h, i), window.addEventListener("pointercancel", f, i);
  };
  return s.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", o, i), ma(a) && (a.addEventListener("focus", (u) => Ta(u, i)), !xa(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), r;
}
function Ei(t) {
  return Us(t) && "ownerSVGElement" in t;
}
function ba(t) {
  return Ei(t) && t.tagName === "svg";
}
const I = (t) => !!(t && t.getVelocity), Pa = [...bi, R, tt], Ma = (t) => Pa.find(Si(t)), Ri = xt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
function Va(t = !0) {
  const e = j(Ue);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: s, register: i } = e, r = So();
  ze(() => {
    if (t)
      return i(r);
  }, [t]);
  const o = qs(() => t && s && s(r), [r, s, t]);
  return !n && s ? [!1, o] : [!0];
}
const Li = xt({ strict: !1 }), Kn = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, wt = {};
for (const t in Kn)
  wt[t] = {
    isEnabled: (e) => Kn[t].some((n) => !!e[n])
  };
function Aa(t) {
  for (const e in t)
    wt[e] = {
      ...wt[e],
      ...t[e]
    };
}
const Ca = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Jt(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || Ca.has(t);
}
let Bi = (t) => !Jt(t);
function Da(t) {
  typeof t == "function" && (Bi = (e) => e.startsWith("on") ? !Jt(e) : t(e));
}
try {
  Da(require("@emotion/is-prop-valid").default);
} catch {
}
function Ea(t, e, n) {
  const s = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (Bi(i) || n === !0 && Jt(i) || !e && !Jt(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (s[i] = t[i]);
  return s;
}
const ee = /* @__PURE__ */ xt({});
function ne(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function kt(t) {
  return typeof t == "string" || Array.isArray(t);
}
const fn = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], dn = ["initial", ...fn];
function se(t) {
  return ne(t.animate) || dn.some((e) => kt(t[e]));
}
function ki(t) {
  return !!(se(t) || t.variants);
}
function Ra(t, e) {
  if (se(t)) {
    const { initial: n, animate: s } = t;
    return {
      initial: n === !1 || kt(n) ? n : void 0,
      animate: kt(s) ? s : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function La(t) {
  const { initial: e, animate: n } = Ra(t, j(ee));
  return te(() => ({ initial: e, animate: n }), [$n(e), $n(n)]);
}
function $n(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const It = {};
function Ba(t) {
  for (const e in t)
    It[e] = t[e], Xe(e) && (It[e].isCSSVariable = !0);
}
function Ii(t, { layout: e, layoutId: n }) {
  return Pt.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!It[t] || t === "opacity");
}
const ka = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Ia = bt.length;
function Fa(t, e, n) {
  let s = "", i = !0;
  for (let r = 0; r < Ia; r++) {
    const o = bt[r], a = t[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const u = Vi(a, cn[o]);
      if (!l) {
        i = !1;
        const c = ka[o] || o;
        s += `${c}(${u}) `;
      }
      n && (e[o] = u);
    }
  }
  return s = s.trim(), n ? s = n(e, i ? "" : s) : i && (s = "none"), s;
}
function mn(t, e, n) {
  const { style: s, vars: i, transformOrigin: r } = t;
  let o = !1, a = !1;
  for (const l in e) {
    const u = e[l];
    if (Pt.has(l)) {
      o = !0;
      continue;
    } else if (Xe(l)) {
      i[l] = u;
      continue;
    } else {
      const c = Vi(u, cn[l]);
      l.startsWith("origin") ? (a = !0, r[l] = c) : s[l] = c;
    }
  }
  if (e.transform || (o || n ? s.transform = Fa(e, t.transform, n) : s.transform && (s.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = r;
    s.transformOrigin = `${l} ${u} ${c}`;
  }
}
const pn = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Fi(t, e, n) {
  for (const s in e)
    !I(e[s]) && !Ii(s, n) && (t[s] = e[s]);
}
function Oa({ transformTemplate: t }, e) {
  return te(() => {
    const n = pn();
    return mn(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function ja(t, e) {
  const n = t.style || {}, s = {};
  return Fi(s, n, t), Object.assign(s, Oa(t, e)), s;
}
function qa(t, e) {
  const n = {}, s = ja(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, s.userSelect = s.WebkitUserSelect = s.WebkitTouchCallout = "none", s.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = s, n;
}
const Na = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, za = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Ha(t, e, n = 1, s = 0, i = !0) {
  t.pathLength = 1;
  const r = i ? Na : za;
  t[r.offset] = T.transform(-s);
  const o = T.transform(e), a = T.transform(n);
  t[r.array] = `${o} ${a}`;
}
function Oi(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  pathLength: i,
  pathSpacing: r = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, u, c) {
  if (mn(t, a, u), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: f } = t;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete h.transformBox), e !== void 0 && (h.x = e), n !== void 0 && (h.y = n), s !== void 0 && (h.scale = s), i !== void 0 && Ha(h, i, r, o, !1);
}
const ji = () => ({
  ...pn(),
  attrs: {}
}), qi = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function Ua(t, e, n, s) {
  const i = te(() => {
    const r = ji();
    return Oi(r, e, qi(s), t.transformTemplate, t.style), {
      ...r.attrs,
      style: { ...r.style }
    };
  }, [e]);
  if (t.style) {
    const r = {};
    Fi(r, t.style, t), i.style = { ...r, ...i.style };
  }
  return i;
}
const _a = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function gn(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(_a.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function Wa(t, e, n, { latestValues: s }, i, r = !1) {
  const a = (gn(t) ? Ua : qa)(e, s, i, t), l = Ea(e, typeof t == "string", r), u = t !== Ns ? { ...l, ...a, ref: n } : {}, { children: c } = e, h = te(() => I(c) ? c.get() : c, [c]);
  return bo(t, {
    ...u,
    children: h
  });
}
function Gn(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function yn(t, e, n, s) {
  if (typeof e == "function") {
    const [i, r] = Gn(s);
    e = e(n !== void 0 ? n : t.custom, i, r);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, r] = Gn(s);
    e = e(n !== void 0 ? n : t.custom, i, r);
  }
  return e;
}
function $t(t) {
  return I(t) ? t.get() : t;
}
function Ka({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, s, i) {
  return {
    latestValues: $a(n, s, i, t),
    renderState: e()
  };
}
function $a(t, e, n, s) {
  const i = {}, r = s(t, {});
  for (const f in r)
    i[f] = $t(r[f]);
  let { initial: o, animate: a } = t;
  const l = se(t), u = ki(t);
  e && u && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const h = c ? a : o;
  if (h && typeof h != "boolean" && !ne(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let d = 0; d < f.length; d++) {
      const p = yn(t, f[d]);
      if (p) {
        const { transitionEnd: y, transition: w, ...g } = p;
        for (const x in g) {
          let v = g[x];
          if (Array.isArray(v)) {
            const P = c ? v.length - 1 : 0;
            v = v[P];
          }
          v !== null && (i[x] = v);
        }
        for (const x in y)
          i[x] = y[x];
      }
    }
  }
  return i;
}
const Ni = (t) => (e, n) => {
  const s = j(ee), i = j(Ue), r = () => Ka(t, e, s, i);
  return n ? r() : Ao(r);
};
function vn(t, e, n) {
  var r;
  const { style: s } = t, i = {};
  for (const o in s)
    (I(s[o]) || e.style && I(e.style[o]) || Ii(o, t) || ((r = n == null ? void 0 : n.getValue(o)) == null ? void 0 : r.liveStyle) !== void 0) && (i[o] = s[o]);
  return i;
}
const Ga = /* @__PURE__ */ Ni({
  scrapeMotionValuesFromProps: vn,
  createRenderState: pn
});
function zi(t, e, n) {
  const s = vn(t, e, n);
  for (const i in t)
    if (I(t[i]) || I(e[i])) {
      const r = bt.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      s[r] = t[i];
    }
  return s;
}
const Za = /* @__PURE__ */ Ni({
  scrapeMotionValuesFromProps: zi,
  createRenderState: ji
}), Ya = Symbol.for("motionComponentSymbol");
function dt(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Xa(t, e, n) {
  return qs(
    (s) => {
      s && t.onMount && t.onMount(s), e && (s ? e.mount(s) : e.unmount()), n && (typeof n == "function" ? n(s) : dt(n) && (n.current = s));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const wn = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Ja = "framerAppearId", Hi = "data-" + wn(Ja), Ui = xt({});
function Qa(t, e, n, s, i) {
  var y, w;
  const { visualElement: r } = j(ee), o = j(Li), a = j(Ue), l = j(Ri).reducedMotion, u = _t(null);
  s = s || o.renderer, !u.current && s && (u.current = s(t, {
    visualState: e,
    parent: r,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, h = j(Ui);
  c && !c.projection && i && (c.type === "html" || c.type === "svg") && tl(u.current, n, i, h);
  const f = _t(!1);
  Po(() => {
    c && f.current && c.update(n, a);
  });
  const d = n[Hi], p = _t(!!d && !((y = window.MotionHandoffIsComplete) != null && y.call(window, d)) && ((w = window.MotionHasOptimisedAnimation) == null ? void 0 : w.call(window, d)));
  return Co(() => {
    c && (f.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), c.scheduleRenderMicrotask(), p.current && c.animationState && c.animationState.animateChanges());
  }), ze(() => {
    c && (!p.current && c.animationState && c.animationState.animateChanges(), p.current && (queueMicrotask(() => {
      var g;
      (g = window.MotionHandoffMarkAsComplete) == null || g.call(window, d);
    }), p.current = !1), c.enteringChildren = void 0);
  }), c;
}
function tl(t, e, n, s) {
  const { layoutId: i, layout: r, drag: o, dragConstraints: a, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : _i(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: r,
    alwaysMeasureLayout: !!o || a && dt(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof r == "string" ? r : "both",
    initialPromotionConfig: s,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function _i(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : _i(t.parent);
}
function ue(t, { forwardMotionProps: e = !1 } = {}, n, s) {
  n && Aa(n);
  const i = gn(t) ? Za : Ga;
  function r(a, l) {
    let u;
    const c = {
      ...j(Ri),
      ...a,
      layoutId: el(a)
    }, { isStatic: h } = c, f = La(a), d = i(a, h);
    if (!h && He) {
      nl(c, n);
      const p = sl(c);
      u = p.MeasureLayout, f.visualElement = Qa(t, d, c, s, p.ProjectionNode);
    }
    return M(ee.Provider, { value: f, children: [u && f.visualElement ? m(u, { visualElement: f.visualElement, ...c }) : null, Wa(t, a, Xa(d, f.visualElement, l), d, h, e)] });
  }
  r.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const o = Mo(r);
  return o[Ya] = t, o;
}
function el({ layoutId: t }) {
  const e = j(zs).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function nl(t, e) {
  const n = j(Li).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const s = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Tt(!1, s, "lazy-strict-mode") : Y(!1, s, "lazy-strict-mode");
  }
}
function sl(t) {
  const { drag: e, layout: n } = wt;
  if (!e && !n)
    return {};
  const s = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? s.MeasureLayout : void 0,
    ProjectionNode: s.ProjectionNode
  };
}
function il(t, e) {
  if (typeof Proxy > "u")
    return ue;
  const n = /* @__PURE__ */ new Map(), s = (r, o) => ue(r, o, t, e), i = (r, o) => (process.env.NODE_ENV !== "production" && Ge(!1, "motion() is deprecated. Use motion.create() instead."), s(r, o));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? s : (n.has(o) || n.set(o, ue(o, void 0, t, e)), n.get(o))
  });
}
function Wi({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function ol({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function rl(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
function he(t) {
  return t === void 0 || t === 1;
}
function Be({ scale: t, scaleX: e, scaleY: n }) {
  return !he(t) || !he(e) || !he(n);
}
function it(t) {
  return Be(t) || Ki(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Ki(t) {
  return Zn(t.x) || Zn(t.y);
}
function Zn(t) {
  return t && t !== "0%";
}
function Qt(t, e, n) {
  const s = t - n, i = e * s;
  return n + i;
}
function Yn(t, e, n, s, i) {
  return i !== void 0 && (t = Qt(t, i, s)), Qt(t, n, s) + e;
}
function ke(t, e = 0, n = 1, s, i) {
  t.min = Yn(t.min, e, n, s, i), t.max = Yn(t.max, e, n, s, i);
}
function $i(t, { x: e, y: n }) {
  ke(t.x, e.translate, e.scale, e.originPoint), ke(t.y, n.translate, n.scale, n.originPoint);
}
const Xn = 0.999999999999, Jn = 1.0000000000001;
function al(t, e, n, s = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let r, o;
  for (let a = 0; a < i; a++) {
    r = n[a], o = r.projectionDelta;
    const { visualElement: l } = r.options;
    l && l.props.style && l.props.style.display === "contents" || (s && r.options.layoutScroll && r.scroll && r !== r.root && pt(t, {
      x: -r.scroll.offset.x,
      y: -r.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, $i(t, o)), s && it(r.latestValues) && pt(t, r.latestValues));
  }
  e.x < Jn && e.x > Xn && (e.x = 1), e.y < Jn && e.y > Xn && (e.y = 1);
}
function mt(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function Qn(t, e, n, s, i = 0.5) {
  const r = D(t.min, t.max, i);
  ke(t, e, n, r, s);
}
function pt(t, e) {
  Qn(t.x, e.x, e.scaleX, e.scale, e.originX), Qn(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function Gi(t, e) {
  return Wi(rl(t.getBoundingClientRect(), e));
}
function ll(t, e, n) {
  const s = Gi(t, n), { scroll: i } = e;
  return i && (mt(s.x, i.offset.x), mt(s.y, i.offset.y)), s;
}
const ts = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), gt = () => ({
  x: ts(),
  y: ts()
}), es = () => ({ min: 0, max: 0 }), E = () => ({
  x: es(),
  y: es()
}), Ie = { current: null }, Zi = { current: !1 };
function cl() {
  if (Zi.current = !0, !!He)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Ie.current = t.matches;
      t.addEventListener("change", e), e();
    } else
      Ie.current = !1;
}
const ul = /* @__PURE__ */ new WeakMap();
function hl(t, e, n) {
  for (const s in e) {
    const i = e[s], r = n[s];
    if (I(i))
      t.addValue(s, i);
    else if (I(r))
      t.addValue(s, vt(i, { owner: t }));
    else if (r !== i)
      if (t.hasValue(s)) {
        const o = t.getValue(s);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(s);
        t.addValue(s, vt(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const s in n)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const ns = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class fl {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, s) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: i, blockInitialAnimation: r, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = an, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = q.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, A.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!r, this.isControllingVariants = se(n), this.isVariantNode = ki(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in h) {
      const d = h[f];
      l[f] !== void 0 && I(d) && d.set(l[f]);
    }
  }
  mount(e) {
    var n;
    this.current = e, ul.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((s, i) => this.bindToMotionValue(i, s)), Zi.current || cl(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ie.current, process.env.NODE_ENV !== "production" && Ge(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var e;
    this.projection && this.projection.unmount(), Q(this.notifyUpdate), Q(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (e = this.parent) == null || e.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const s = this.features[n];
      s && (s.unmount(), s.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const s = Pt.has(e);
    s && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && A.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let r;
    window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), r && r(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in wt) {
      const n = wt[e];
      if (!n)
        continue;
      const { isEnabled: s, Feature: i } = n;
      if (!this.features[e] && i && s(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const r = this.features[e];
        r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : E();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < ns.length; s++) {
      const i = ns[s];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const r = "on" + i, o = e[r];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = hl(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const s = this.values.get(e);
    n !== s && (s && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = vt(n === null ? void 0 : n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let s = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return s != null && (typeof s == "string" && (Hs(s) || _s(s)) ? s = parseFloat(s) : !Ma(s) && tt.test(n) && (s = Mi(e, n)), this.setBaseTarget(e, I(s) ? s.get() : s)), I(s) ? s.get() : s;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var r;
    const { initial: n } = this.props;
    let s;
    if (typeof n == "string" || typeof n == "object") {
      const o = yn(this.props, n, (r = this.presenceContext) == null ? void 0 : r.custom);
      o && (s = o[e]);
    }
    if (n && s !== void 0)
      return s;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !I(i) ? i : this.initialValues[e] !== void 0 && s === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new $e()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
  scheduleRenderMicrotask() {
    un.render(this.render);
  }
}
class Yi extends fl {
  constructor() {
    super(...arguments), this.KeyframeResolver = fa;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    I(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Xi(t, { style: e, vars: n }, s, i) {
  const r = t.style;
  let o;
  for (o in e)
    r[o] = e[o];
  i == null || i.applyProjectionStyles(r, s);
  for (o in n)
    r.setProperty(o, n[o]);
}
function dl(t) {
  return window.getComputedStyle(t);
}
class ml extends Yi {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Xi;
  }
  readValueFromInstance(e, n) {
    var s;
    if (Pt.has(n))
      return (s = this.projection) != null && s.isProjecting ? Ve(n) : Er(e, n);
    {
      const i = dl(e), r = (Xe(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Gi(e, n);
  }
  build(e, n, s) {
    mn(e, n, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return vn(e, n, s);
  }
}
const Ji = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function pl(t, e, n, s) {
  Xi(t, e, void 0, s);
  for (const i in e.attrs)
    t.setAttribute(Ji.has(i) ? i : wn(i), e.attrs[i]);
}
class gl extends Yi {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = E;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Pt.has(n)) {
      const s = Pi(n);
      return s && s.default || 0;
    }
    return n = Ji.has(n) ? n : wn(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return zi(e, n, s);
  }
  build(e, n, s) {
    Oi(e, n, this.isSVGTag, s.transformTemplate, s.style);
  }
  renderInstance(e, n, s, i) {
    pl(e, n, s, i);
  }
  mount(e) {
    this.isSVGTag = qi(e.tagName), super.mount(e);
  }
}
const yl = (t, e) => gn(t) ? new gl(e) : new ml(e, {
  allowProjection: t !== Ns
});
function yt(t, e, n) {
  const s = t.getProps();
  return yn(s, e, n !== void 0 ? n : s.custom, t);
}
const Fe = (t) => Array.isArray(t);
function vl(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, vt(n));
}
function wl(t) {
  return Fe(t) ? t[t.length - 1] || 0 : t;
}
function xl(t, e) {
  const n = yt(t, e);
  let { transitionEnd: s = {}, transition: i = {}, ...r } = n || {};
  r = { ...r, ...s };
  for (const o in r) {
    const a = wl(r[o]);
    vl(t, o, a);
  }
}
function Tl(t) {
  return !!(I(t) && t.add);
}
function Oe(t, e) {
  const n = t.getValue("willChange");
  if (Tl(n))
    return n.add(e);
  if (!n && X.WillChange) {
    const s = new X.WillChange("auto");
    t.addValue("willChange", s), s.add(e);
  }
}
function Qi(t) {
  return t.props[Hi];
}
const Sl = (t) => t !== null;
function bl(t, { repeat: e, repeatType: n = "loop" }, s) {
  const i = t.filter(Sl), r = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !r || s === void 0 ? i[r] : s;
}
const Pl = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Ml = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Vl = {
  type: "keyframes",
  duration: 0.8
}, Al = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Cl = (t, { keyframes: e }) => e.length > 2 ? Vl : Pt.has(t) ? t.startsWith("scale") ? Ml(e[1]) : Pl : Al;
function Dl({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: i, repeat: r, repeatType: o, repeatDelay: a, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const xn = (t, e, n, s = {}, i, r) => (o) => {
  const a = ln(s, t) || {}, l = a.delay || s.delay || 0;
  let { elapsed: u = 0 } = s;
  u = u - /* @__PURE__ */ K(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (f) => {
      e.set(f), a.onUpdate && a.onUpdate(f);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: r ? void 0 : i
  };
  Dl(a) || Object.assign(c, Cl(t, c)), c.duration && (c.duration = /* @__PURE__ */ K(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ K(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let h = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (Re(c), c.delay === 0 && (h = !0)), (X.instantAnimations || X.skipAnimations) && (h = !0, Re(c), c.delay = 0), c.allowFlatten = !a.type && !a.ease, h && !r && e.get() !== void 0) {
    const f = bl(c.keyframes, a);
    if (f !== void 0) {
      A.update(() => {
        c.onUpdate(f), c.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new rn(c) : new Qr(c);
};
function El({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function to(t, e, { delay: n = 0, transitionOverride: s, type: i } = {}) {
  let { transition: r = t.getDefaultTransition(), transitionEnd: o, ...a } = e;
  s && (r = s);
  const l = [], u = i && t.animationState && t.animationState.getState()[i];
  for (const c in a) {
    const h = t.getValue(c, t.latestValues[c] ?? null), f = a[c];
    if (f === void 0 || u && El(u, c))
      continue;
    const d = {
      delay: n,
      ...ln(r || {}, c)
    }, p = h.get();
    if (p !== void 0 && !h.isAnimating && !Array.isArray(f) && f === p && !d.velocity)
      continue;
    let y = !1;
    if (window.MotionHandoffAnimation) {
      const g = Qi(t);
      if (g) {
        const x = window.MotionHandoffAnimation(g, c, A);
        x !== null && (d.startTime = x, y = !0);
      }
    }
    Oe(t, c), h.start(xn(c, h, f, t.shouldReduceMotion && Ti.has(c) ? { type: !1 } : d, t, y));
    const w = h.animation;
    w && l.push(w);
  }
  return o && Promise.all(l).then(() => {
    A.update(() => {
      o && xl(t, o);
    });
  }), l;
}
function eo(t, e, n, s = 0, i = 1) {
  const r = Array.from(t).sort((u, c) => u.sortNodePosition(c)).indexOf(e), o = t.size, a = (o - 1) * s;
  return typeof n == "function" ? n(r, o) : i === 1 ? r * s : a - r * s;
}
function je(t, e, n = {}) {
  var l;
  const s = yt(t, e, n.type === "exit" ? (l = t.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: i = t.getDefaultTransition() || {} } = s || {};
  n.transitionOverride && (i = n.transitionOverride);
  const r = s ? () => Promise.all(to(t, s, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: h, staggerDirection: f } = i;
    return Rl(t, e, u, c, h, f, n);
  } : () => Promise.resolve(), { when: a } = i;
  if (a) {
    const [u, c] = a === "beforeChildren" ? [r, o] : [o, r];
    return u().then(() => c());
  } else
    return Promise.all([r(), o(n.delay)]);
}
function Rl(t, e, n = 0, s = 0, i = 0, r = 1, o) {
  const a = [];
  for (const l of t.variantChildren)
    l.notify("AnimationStart", e), a.push(je(l, e, {
      ...o,
      delay: n + (typeof s == "function" ? 0 : s) + eo(t.variantChildren, l, s, i, r)
    }).then(() => l.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function Ll(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let s;
  if (Array.isArray(e)) {
    const i = e.map((r) => je(t, r, n));
    s = Promise.all(i);
  } else if (typeof e == "string")
    s = je(t, e, n);
  else {
    const i = typeof e == "function" ? yt(t, e, n.custom) : e;
    s = Promise.all(to(t, i, n));
  }
  return s.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function no(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let s = 0; s < n; s++)
    if (e[s] !== t[s])
      return !1;
  return !0;
}
const Bl = dn.length;
function so(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? so(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < Bl; n++) {
    const s = dn[n], i = t.props[s];
    (kt(i) || i === !1) && (e[s] = i);
  }
  return e;
}
const kl = [...fn].reverse(), Il = fn.length;
function Fl(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: s }) => Ll(t, n, s)));
}
function Ol(t) {
  let e = Fl(t), n = ss(), s = !0;
  const i = (l) => (u, c) => {
    var f;
    const h = yt(t, c, l === "exit" ? (f = t.presenceContext) == null ? void 0 : f.custom : void 0);
    if (h) {
      const { transition: d, transitionEnd: p, ...y } = h;
      u = { ...u, ...y, ...p };
    }
    return u;
  };
  function r(l) {
    e = l(t);
  }
  function o(l) {
    const { props: u } = t, c = so(t.parent) || {}, h = [], f = /* @__PURE__ */ new Set();
    let d = {}, p = 1 / 0;
    for (let w = 0; w < Il; w++) {
      const g = kl[w], x = n[g], v = u[g] !== void 0 ? u[g] : c[g], P = kt(v), S = g === l ? x.isActive : null;
      S === !1 && (p = w);
      let V = v === c[g] && v !== u[g] && P;
      if (V && s && t.manuallyAnimateOnMount && (V = !1), x.protectedKeys = { ...d }, // If it isn't active and hasn't *just* been set as inactive
      !x.isActive && S === null || // If we didn't and don't have any defined prop for this animation type
      !v && !x.prevProp || // Or if the prop doesn't define an animation
      ne(v) || typeof v == "boolean")
        continue;
      const L = jl(x.prevProp, v);
      let b = L || // If we're making this variant active, we want to always make it active
      g === l && x.isActive && !V && P || // If we removed a higher-priority variant (i is in reverse order)
      w > p && P, O = !1;
      const N = Array.isArray(v) ? v : [v];
      let ct = N.reduce(i(g), {});
      S === !1 && (ct = {});
      const { prevResolvedValues: Tn = {} } = x, wo = {
        ...Tn,
        ...ct
      }, Sn = (B) => {
        b = !0, f.has(B) && (O = !0, f.delete(B)), x.needsAnimating[B] = !0;
        const z = t.getValue(B);
        z && (z.liveStyle = !1);
      };
      for (const B in wo) {
        const z = ct[B], nt = Tn[B];
        if (d.hasOwnProperty(B))
          continue;
        let ut = !1;
        Fe(z) && Fe(nt) ? ut = !no(z, nt) : ut = z !== nt, ut ? z != null ? Sn(B) : f.add(B) : z !== void 0 && f.has(B) ? Sn(B) : x.protectedKeys[B] = !0;
      }
      x.prevProp = v, x.prevResolvedValues = ct, x.isActive && (d = { ...d, ...ct }), s && t.blockInitialAnimation && (b = !1);
      const bn = V && L;
      b && (!bn || O) && h.push(...N.map((B) => {
        const z = { type: g };
        if (typeof B == "string" && s && !bn && t.manuallyAnimateOnMount && t.parent) {
          const { parent: nt } = t, ut = yt(nt, B);
          if (nt.enteringChildren && ut) {
            const { delayChildren: xo } = ut.transition || {};
            z.delay = eo(nt.enteringChildren, t, xo);
          }
        }
        return {
          animation: B,
          options: z
        };
      }));
    }
    if (f.size) {
      const w = {};
      if (typeof u.initial != "boolean") {
        const g = yt(t, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        g && g.transition && (w.transition = g.transition);
      }
      f.forEach((g) => {
        const x = t.getBaseTarget(g), v = t.getValue(g);
        v && (v.liveStyle = !0), w[g] = x ?? null;
      }), h.push({ animation: w });
    }
    let y = !!h.length;
    return s && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (y = !1), s = !1, y ? e(h) : Promise.resolve();
  }
  function a(l, u) {
    var h;
    if (n[l].isActive === u)
      return Promise.resolve();
    (h = t.variantChildren) == null || h.forEach((f) => {
      var d;
      return (d = f.animationState) == null ? void 0 : d.setActive(l, u);
    }), n[l].isActive = u;
    const c = o(l);
    for (const f in n)
      n[f].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: a,
    setAnimateFunction: r,
    getState: () => n,
    reset: () => {
      n = ss(), s = !0;
    }
  };
}
function jl(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !no(e, t) : !1;
}
function st(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function ss() {
  return {
    animate: st(!0),
    whileInView: st(),
    whileHover: st(),
    whileTap: st(),
    whileDrag: st(),
    whileFocus: st(),
    exit: st()
  };
}
class et {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class ql extends et {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Ol(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    ne(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let Nl = 0;
class zl extends et {
  constructor() {
    super(...arguments), this.id = Nl++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: s } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === s)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Hl = {
  animation: {
    Feature: ql
  },
  exit: {
    Feature: zl
  }
};
function Ft(t, e, n, s = { passive: !0 }) {
  return t.addEventListener(e, n, s), () => t.removeEventListener(e, n);
}
function Nt(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Ul = (t) => (e) => hn(e) && t(e, Nt(e));
function Ct(t, e, n, s) {
  return Ft(t, e, Ul(n), s);
}
const io = 1e-4, _l = 1 - io, Wl = 1 + io, oo = 0.01, Kl = 0 - oo, $l = 0 + oo;
function F(t) {
  return t.max - t.min;
}
function Gl(t, e, n) {
  return Math.abs(t - e) <= n;
}
function is(t, e, n, s = 0.5) {
  t.origin = s, t.originPoint = D(e.min, e.max, t.origin), t.scale = F(n) / F(e), t.translate = D(n.min, n.max, t.origin) - t.originPoint, (t.scale >= _l && t.scale <= Wl || isNaN(t.scale)) && (t.scale = 1), (t.translate >= Kl && t.translate <= $l || isNaN(t.translate)) && (t.translate = 0);
}
function Dt(t, e, n, s) {
  is(t.x, e.x, n.x, s ? s.originX : void 0), is(t.y, e.y, n.y, s ? s.originY : void 0);
}
function os(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + F(e);
}
function Zl(t, e, n) {
  os(t.x, e.x, n.x), os(t.y, e.y, n.y);
}
function rs(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + F(e);
}
function Et(t, e, n) {
  rs(t.x, e.x, n.x), rs(t.y, e.y, n.y);
}
function U(t) {
  return [t("x"), t("y")];
}
const ro = ({ current: t }) => t ? t.ownerDocument.defaultView : null, as = (t, e) => Math.abs(t - e);
function Yl(t, e) {
  const n = as(t.x, e.x), s = as(t.y, e.y);
  return Math.sqrt(n ** 2 + s ** 2);
}
class ao {
  constructor(e, n, { transformPagePoint: s, contextWindow: i = window, dragSnapToOrigin: r = !1, distanceThreshold: o = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = de(this.lastMoveEventInfo, this.history), d = this.startEvent !== null, p = Yl(f.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!d && !p)
        return;
      const { point: y } = f, { timestamp: w } = k;
      this.history.push({ ...y, timestamp: w });
      const { onStart: g, onMove: x } = this.handlers;
      d || (g && g(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), x && x(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, d) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = fe(d, this.transformPagePoint), A.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, d) => {
      this.end();
      const { onEnd: p, onSessionEnd: y, resumeAnimation: w } = this.handlers;
      if (this.dragSnapToOrigin && w && w(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = de(f.type === "pointercancel" ? this.lastMoveEventInfo : fe(d, this.transformPagePoint), this.history);
      this.startEvent && p && p(f, g), y && y(f, g);
    }, !hn(e))
      return;
    this.dragSnapToOrigin = r, this.handlers = n, this.transformPagePoint = s, this.distanceThreshold = o, this.contextWindow = i || window;
    const a = Nt(e), l = fe(a, this.transformPagePoint), { point: u } = l, { timestamp: c } = k;
    this.history = [{ ...u, timestamp: c }];
    const { onSessionStart: h } = n;
    h && h(e, de(l, this.history)), this.removeListeners = Ot(Ct(this.contextWindow, "pointermove", this.handlePointerMove), Ct(this.contextWindow, "pointerup", this.handlePointerUp), Ct(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), Q(this.updatePoint);
  }
}
function fe(t, e) {
  return e ? { point: e(t.point) } : t;
}
function ls(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function de({ point: t }, e) {
  return {
    point: t,
    delta: ls(t, lo(e)),
    offset: ls(t, Xl(e)),
    velocity: Jl(e, 0.1)
  };
}
function Xl(t) {
  return t[0];
}
function lo(t) {
  return t[t.length - 1];
}
function Jl(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, s = null;
  const i = lo(t);
  for (; n >= 0 && (s = t[n], !(i.timestamp - s.timestamp > /* @__PURE__ */ K(e))); )
    n--;
  if (!s)
    return { x: 0, y: 0 };
  const r = /* @__PURE__ */ $(i.timestamp - s.timestamp);
  if (r === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (i.x - s.x) / r,
    y: (i.y - s.y) / r
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Ql(t, { min: e, max: n }, s) {
  return e !== void 0 && t < e ? t = s ? D(e, t, s.min) : Math.max(t, e) : n !== void 0 && t > n && (t = s ? D(n, t, s.max) : Math.min(t, n)), t;
}
function cs(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function tc(t, { top: e, left: n, bottom: s, right: i }) {
  return {
    x: cs(t.x, n, i),
    y: cs(t.y, e, s)
  };
}
function us(t, e) {
  let n = e.min - t.min, s = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, s] = [s, n]), { min: n, max: s };
}
function ec(t, e) {
  return {
    x: us(t.x, e.x),
    y: us(t.y, e.y)
  };
}
function nc(t, e) {
  let n = 0.5;
  const s = F(t), i = F(e);
  return i > s ? n = /* @__PURE__ */ Rt(e.min, e.max - s, t.min) : s > i && (n = /* @__PURE__ */ Rt(t.min, t.max - i, e.min)), Z(0, 1, n);
}
function sc(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const qe = 0.35;
function ic(t = qe) {
  return t === !1 ? t = 0 : t === !0 && (t = qe), {
    x: hs(t, "left", "right"),
    y: hs(t, "top", "bottom")
  };
}
function hs(t, e, n) {
  return {
    min: fs(t, e),
    max: fs(t, n)
  };
}
function fs(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const oc = /* @__PURE__ */ new WeakMap();
class rc {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = E(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1, distanceThreshold: s } = {}) {
    const { presenceContext: i } = this.visualElement;
    if (i && i.isPresent === !1)
      return;
    const r = (h) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Nt(h).point);
    }, o = (h, f) => {
      const { drag: d, dragPropagation: p, onDragStart: y } = this.getProps();
      if (d && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = ya(d), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), U((g) => {
        let x = this.getAxisMotionValue(g).get() || 0;
        if (G.test(x)) {
          const { projection: v } = this.visualElement;
          if (v && v.layout) {
            const P = v.layout.layoutBox[g];
            P && (x = F(P) * (parseFloat(x) / 100));
          }
        }
        this.originPoint[g] = x;
      }), y && A.postRender(() => y(h, f)), Oe(this.visualElement, "transform");
      const { animationState: w } = this.visualElement;
      w && w.setActive("whileDrag", !0);
    }, a = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: d, dragDirectionLock: p, onDirectionLock: y, onDrag: w } = this.getProps();
      if (!d && !this.openDragLock)
        return;
      const { offset: g } = f;
      if (p && this.currentDirection === null) {
        this.currentDirection = ac(g), this.currentDirection !== null && y && y(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, g), this.updateAxis("y", f.point, g), this.visualElement.render(), w && w(h, f);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => U((h) => {
      var f;
      return this.getAnimationState(h) === "paused" && ((f = this.getAxisMotionValue(h).animation) == null ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new ao(e, {
      onSessionStart: r,
      onStart: o,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      distanceThreshold: s,
      contextWindow: ro(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(e, n) {
    const s = e || this.latestPointerEvent, i = n || this.latestPanInfo, r = this.isDragging;
    if (this.cancel(), !r || !i || !s)
      return;
    const { velocity: o } = i;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && A.postRender(() => a(s, i));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: s } = this.getProps();
    !s && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, s) {
    const { drag: i } = this.getProps();
    if (!s || !Ut(e, i, this.currentDirection))
      return;
    const r = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + s[e];
    this.constraints && this.constraints[e] && (o = Ql(o, this.constraints[e], this.elastic[e])), r.set(o);
  }
  resolveConstraints() {
    var r;
    const { dragConstraints: e, dragElastic: n } = this.getProps(), s = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (r = this.visualElement.projection) == null ? void 0 : r.layout, i = this.constraints;
    e && dt(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && s ? this.constraints = tc(s.layoutBox, e) : this.constraints = !1, this.elastic = ic(n), i !== this.constraints && s && this.constraints && !this.hasMutatedConstraints && U((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = sc(s.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !dt(e))
      return !1;
    const s = e.current;
    Y(s !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const r = ll(s, i.root, this.visualElement.getTransformPagePoint());
    let o = ec(i.layout.layoutBox, r);
    if (n) {
      const a = n(ol(o));
      this.hasMutatedConstraints = !!a, a && (o = Wi(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: s, dragElastic: i, dragTransition: r, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, u = U((c) => {
      if (!Ut(c, n, this.currentDirection))
        return;
      let h = l && l[c] || {};
      o && (h = { min: 0, max: 0 });
      const f = i ? 200 : 1e6, d = i ? 40 : 1e7, p = {
        type: "inertia",
        velocity: s ? e[c] : 0,
        bounceStiffness: f,
        bounceDamping: d,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...r,
        ...h
      };
      return this.startAxisValueAnimation(c, p);
    });
    return Promise.all(u).then(a);
  }
  startAxisValueAnimation(e, n) {
    const s = this.getAxisMotionValue(e);
    return Oe(this.visualElement, e), s.start(xn(e, s, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    U((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    U((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, s = this.visualElement.getProps(), i = s[n];
    return i || this.visualElement.getValue(e, (s.initial ? s.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    U((n) => {
      const { drag: s } = this.getProps();
      if (!Ut(n, s, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, r = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: o, max: a } = i.layout.layoutBox[n];
        r.set(e[n] - D(o, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: s } = this.visualElement;
    if (!dt(n) || !s || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    U((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const l = a.get();
        i[o] = nc({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: r } = this.visualElement.getProps();
    this.visualElement.current.style.transform = r ? r({}, "") : "none", s.root && s.root.updateScroll(), s.updateLayout(), this.resolveConstraints(), U((o) => {
      if (!Ut(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: u } = this.constraints[o];
      a.set(D(l, u, i[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    oc.set(this.visualElement, this);
    const e = this.visualElement.current, n = Ct(e, "pointerdown", (l) => {
      const { drag: u, dragListener: c = !0 } = this.getProps();
      u && c && this.start(l);
    }), s = () => {
      const { dragConstraints: l } = this.getProps();
      dt(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, r = i.addEventListener("measure", s);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), A.read(s);
    const o = Ft(window, "resize", () => this.scalePositionWithinConstraints()), a = i.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: u }) => {
      this.isDragging && u && (U((c) => {
        const h = this.getAxisMotionValue(c);
        h && (this.originPoint[c] += l[c].translate, h.set(h.get() + l[c].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), r(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: s = !1, dragPropagation: i = !1, dragConstraints: r = !1, dragElastic: o = qe, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: s,
      dragPropagation: i,
      dragConstraints: r,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function Ut(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function ac(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class lc extends et {
  constructor(e) {
    super(e), this.removeGroupControls = _, this.removeListeners = _, this.controls = new rc(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || _;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const ds = (t) => (e, n) => {
  t && A.postRender(() => t(e, n));
};
class cc extends et {
  constructor() {
    super(...arguments), this.removePointerDownListener = _;
  }
  onPointerDown(e) {
    this.session = new ao(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: ro(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: s, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: ds(e),
      onStart: ds(n),
      onMove: s,
      onEnd: (r, o) => {
        delete this.session, i && A.postRender(() => i(r, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Ct(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Gt = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function ms(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Mt = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (T.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = ms(t, e.target.x), s = ms(t, e.target.y);
    return `${n}% ${s}%`;
  }
}, uc = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const s = t, i = tt.parse(t);
    if (i.length > 5)
      return s;
    const r = tt.createTransformer(t), o = typeof i[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    i[0 + o] /= a, i[1 + o] /= l;
    const u = D(a, l, 0.5);
    return typeof i[2 + o] == "number" && (i[2 + o] /= u), typeof i[3 + o] == "number" && (i[3 + o] /= u), r(i);
  }
};
let me = !1;
class hc extends Vo {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s, layoutId: i } = this.props, { projection: r } = e;
    Ba(fc), r && (n.group && n.group.add(r), s && s.register && i && s.register(r), me && r.root.didUpdate(), r.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), r.setOptions({
      ...r.options,
      onExitComplete: () => this.safeToRemove()
    })), Gt.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: s, drag: i, isPresent: r } = this.props, { projection: o } = s;
    return o && (o.isPresent = r, me = !0, i || e.layoutDependency !== n || n === void 0 || e.isPresent !== r ? o.willUpdate() : this.safeToRemove(), e.isPresent !== r && (r ? o.promote() : o.relegate() || A.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), un.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: s } = this.props, { projection: i } = e;
    me = !0, i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), s && s.deregister && s.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function co(t) {
  const [e, n] = Va(), s = j(zs);
  return m(hc, { ...t, layoutGroup: s, switchLayoutGroup: j(Ui), isPresent: e, safeToRemove: n });
}
const fc = {
  borderRadius: {
    ...Mt,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Mt,
  borderTopRightRadius: Mt,
  borderBottomLeftRadius: Mt,
  borderBottomRightRadius: Mt,
  boxShadow: uc
};
function dc(t, e, n) {
  const s = I(t) ? t : vt(t);
  return s.start(xn("", s, e, n)), s.animation;
}
const mc = (t, e) => t.depth - e.depth;
class pc {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    _e(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    We(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(mc), this.isDirty = !1, this.children.forEach(e);
  }
}
function gc(t, e) {
  const n = q.now(), s = ({ timestamp: i }) => {
    const r = i - n;
    r >= e && (Q(s), t(r - e));
  };
  return A.setup(s, !0), () => Q(s);
}
const uo = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], yc = uo.length, ps = (t) => typeof t == "string" ? parseFloat(t) : t, gs = (t) => typeof t == "number" || T.test(t);
function vc(t, e, n, s, i, r) {
  i ? (t.opacity = D(0, n.opacity ?? 1, wc(s)), t.opacityExit = D(e.opacity ?? 1, 0, xc(s))) : r && (t.opacity = D(e.opacity ?? 1, n.opacity ?? 1, s));
  for (let o = 0; o < yc; o++) {
    const a = `border${uo[o]}Radius`;
    let l = ys(e, a), u = ys(n, a);
    if (l === void 0 && u === void 0)
      continue;
    l || (l = 0), u || (u = 0), l === 0 || u === 0 || gs(l) === gs(u) ? (t[a] = Math.max(D(ps(l), ps(u), s), 0), (G.test(u) || G.test(l)) && (t[a] += "%")) : t[a] = u;
  }
  (e.rotate || n.rotate) && (t.rotate = D(e.rotate || 0, n.rotate || 0, s));
}
function ys(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const wc = /* @__PURE__ */ ho(0, 0.5, Js), xc = /* @__PURE__ */ ho(0.5, 0.95, _);
function ho(t, e, n) {
  return (s) => s < t ? 0 : s > e ? 1 : n(/* @__PURE__ */ Rt(t, e, s));
}
function vs(t, e) {
  t.min = e.min, t.max = e.max;
}
function H(t, e) {
  vs(t.x, e.x), vs(t.y, e.y);
}
function ws(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function xs(t, e, n, s, i) {
  return t -= e, t = Qt(t, 1 / n, s), i !== void 0 && (t = Qt(t, 1 / i, s)), t;
}
function Tc(t, e = 0, n = 1, s = 0.5, i, r = t, o = t) {
  if (G.test(e) && (e = parseFloat(e), e = D(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = D(r.min, r.max, s);
  t === r && (a -= e), t.min = xs(t.min, e, n, a, i), t.max = xs(t.max, e, n, a, i);
}
function Ts(t, e, [n, s, i], r, o) {
  Tc(t, e[n], e[s], e[i], e.scale, r, o);
}
const Sc = ["x", "scaleX", "originX"], bc = ["y", "scaleY", "originY"];
function Ss(t, e, n, s) {
  Ts(t.x, e, Sc, n ? n.x : void 0, s ? s.x : void 0), Ts(t.y, e, bc, n ? n.y : void 0, s ? s.y : void 0);
}
function bs(t) {
  return t.translate === 0 && t.scale === 1;
}
function fo(t) {
  return bs(t.x) && bs(t.y);
}
function Ps(t, e) {
  return t.min === e.min && t.max === e.max;
}
function Pc(t, e) {
  return Ps(t.x, e.x) && Ps(t.y, e.y);
}
function Ms(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function mo(t, e) {
  return Ms(t.x, e.x) && Ms(t.y, e.y);
}
function Vs(t) {
  return F(t.x) / F(t.y);
}
function As(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class Mc {
  constructor() {
    this.members = [];
  }
  add(e) {
    _e(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (We(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let s;
    for (let i = n; i >= 0; i--) {
      const r = this.members[i];
      if (r.isPresent !== !1) {
        s = r;
        break;
      }
    }
    return s ? (this.promote(s), !0) : !1;
  }
  promote(e, n) {
    const s = this.lead;
    if (e !== s && (this.prevLead = s, this.lead = e, e.show(), s)) {
      s.instance && s.scheduleRender(), e.scheduleRender(), e.resumeFrom = s, n && (e.resumeFrom.preserveOpacity = !0), s.snapshot && (e.snapshot = s.snapshot, e.snapshot.latestValues = s.animationValues || s.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && s.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: s } = e;
      n.onExitComplete && n.onExitComplete(), s && s.options.onExitComplete && s.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Vc(t, e, n) {
  let s = "";
  const i = t.x.translate / e.x, r = t.y.translate / e.y, o = (n == null ? void 0 : n.z) || 0;
  if ((i || r || o) && (s = `translate3d(${i}px, ${r}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (s += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: u, rotate: c, rotateX: h, rotateY: f, skewX: d, skewY: p } = n;
    u && (s = `perspective(${u}px) ${s}`), c && (s += `rotate(${c}deg) `), h && (s += `rotateX(${h}deg) `), f && (s += `rotateY(${f}deg) `), d && (s += `skewX(${d}deg) `), p && (s += `skewY(${p}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (s += `scale(${a}, ${l})`), s || "none";
}
const pe = ["", "X", "Y", "Z"], Ac = 1e3;
let Cc = 0;
function ge(t, e, n, s) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), s && (s[t] = 0));
}
function po(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = Qi(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: r } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", A, !(i || r));
  }
  const { parent: s } = t;
  s && !s.hasCheckedOptimisedAppear && po(s);
}
function go({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: s, resetTransform: i }) {
  return class {
    constructor(o = {}, a = e == null ? void 0 : e()) {
      this.id = Cc++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Rc), this.nodes.forEach(Ic), this.nodes.forEach(Fc), this.nodes.forEach(Lc);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new pc());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new $e()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = Ei(o) && !ba(o), this.instance = o;
      const { layoutId: a, layout: l, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let c, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        A.read(() => {
          h = window.innerWidth;
        }), t(o, () => {
          const d = window.innerWidth;
          d !== h && (h = d, this.root.updateBlockedByResize = !0, c && c(), c = gc(f, 250), Gt.hasAnimatedSinceResize && (Gt.hasAnimatedSinceResize = !1, this.nodes.forEach(Es)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && u && (a || l) && this.addEventListener("didUpdate", ({ delta: c, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: d }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || u.getDefaultTransition() || zc, { onLayoutAnimationStart: y, onLayoutAnimationComplete: w } = u.getProps(), g = !this.targetLayout || !mo(this.targetLayout, d), x = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || x || h && (g || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const v = {
            ...ln(p, "layout"),
            onPlay: y,
            onComplete: w
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (v.delay = 0, v.type = !1), this.startAnimation(v), this.setAnimationOrigin(c, x);
        } else
          h || Es(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = d;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Q(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Oc), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && po(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let c = 0; c < this.path.length; c++) {
        const h = this.path[c];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Cs);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Ds);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(kc), this.nodes.forEach(Dc), this.nodes.forEach(Ec)) : this.nodes.forEach(Ds), this.clearAllSnapshots();
      const a = q.now();
      k.delta = Z(0, 1e3 / 60, a - k.timestamp), k.timestamp = a, k.isProcessing = !0, ie.update.process(k), ie.preRender.process(k), ie.render.process(k), k.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, un.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(Bc), this.sharedNodes.forEach(jc);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, A.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      A.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !F(this.snapshot.measuredBox.x) && !F(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = E(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const l = s(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !fo(this.projectionDelta), l = this.getTransformTemplate(), u = l ? l(this.latestValues, "") : void 0, c = u !== this.prevTransformTemplateValue;
      o && this.instance && (a || it(this.latestValues) || c) && (i(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), Hc(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return E();
      const a = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(Uc))) {
        const { scroll: c } = this.root;
        c && (mt(a.x, c.offset.x), mt(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      var l;
      const a = E();
      if (H(a, o), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: h, options: f } = c;
        c !== this.root && h && f.layoutScroll && (h.wasRoot && H(a, o), mt(a.x, h.offset.x), mt(a.y, h.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1) {
      const l = E();
      H(l, o);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        !a && c.options.layoutScroll && c.scroll && c !== c.root && pt(l, {
          x: -c.scroll.offset.x,
          y: -c.scroll.offset.y
        }), it(c.latestValues) && pt(l, c.latestValues);
      }
      return it(this.latestValues) && pt(l, this.latestValues), l;
    }
    removeTransform(o) {
      const a = E();
      H(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const u = this.path[l];
        if (!u.instance || !it(u.latestValues))
          continue;
        Be(u.latestValues) && u.updateSnapshot();
        const c = E(), h = u.measurePageBox();
        H(c, h), Ss(a, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, c);
      }
      return it(this.latestValues) && Ss(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== k.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var f;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || (f = this.parent) != null && f.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: c, layoutId: h } = this.options;
      if (!(!this.layout || !(c || h))) {
        if (this.resolvedRelativeTargetAt = k.timestamp, !this.targetDelta && !this.relativeTarget) {
          const d = this.getClosestProjectingParent();
          d && d.layout && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = E(), this.relativeTargetOrigin = E(), Et(this.relativeTargetOrigin, this.layout.layoutBox, d.layout.layoutBox), H(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = E(), this.targetWithTransforms = E()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Zl(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : H(this.target, this.layout.layoutBox), $i(this.target, this.targetDelta)) : H(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const d = this.getClosestProjectingParent();
          d && !!d.resumingFrom == !!this.resumingFrom && !d.options.layoutScroll && d.target && this.animationProgress !== 1 ? (this.relativeParent = d, this.forceRelativeParentToResolveTarget(), this.relativeTarget = E(), this.relativeTargetOrigin = E(), Et(this.relativeTargetOrigin, this.target, d.target), H(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Be(this.parent.latestValues) || Ki(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var p;
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === k.timestamp && (l = !1), l)
        return;
      const { layout: u, layoutId: c } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || c))
        return;
      H(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      al(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = E());
      const { target: d } = o;
      if (!d) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (ws(this.prevProjectionDelta.x, this.projectionDelta.x), ws(this.prevProjectionDelta.y, this.projectionDelta.y)), Dt(this.projectionDelta, this.layoutCorrected, d, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !As(this.projectionDelta.x, this.prevProjectionDelta.x) || !As(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = gt(), this.projectionDelta = gt(), this.projectionDeltaWithTransform = gt();
    }
    setAnimationOrigin(o, a = !1) {
      const l = this.snapshot, u = l ? l.latestValues : {}, c = { ...this.latestValues }, h = gt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = E(), d = l ? l.source : void 0, p = this.layout ? this.layout.source : void 0, y = d !== p, w = this.getStack(), g = !w || w.members.length <= 1, x = !!(y && !g && this.options.crossfade === !0 && !this.path.some(Nc));
      this.animationProgress = 0;
      let v;
      this.mixTargetDelta = (P) => {
        const S = P / 1e3;
        Rs(h.x, o.x, S), Rs(h.y, o.y, S), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Et(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), qc(this.relativeTarget, this.relativeTargetOrigin, f, S), v && Pc(this.relativeTarget, v) && (this.isProjectionDirty = !1), v || (v = E()), H(v, this.relativeTarget)), y && (this.animationValues = c, vc(c, u, this.latestValues, S, x, g)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = S;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var a, l, u;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(), (u = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || u.stop(), this.pendingAnimation && (Q(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = A.update(() => {
        Gt.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = vt(0)), this.currentAnimation = dc(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (c) => {
            this.mixTargetDelta(c), o.onUpdate && o.onUpdate(c);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Ac), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: u, latestValues: c } = o;
      if (!(!a || !l || !u)) {
        if (this !== o && this.layout && u && yo(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          l = this.target || E();
          const h = F(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + h;
          const f = F(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + f;
        }
        H(a, l), pt(a, c), Dt(this.projectionDeltaWithTransform, this.layoutCorrected, a, c);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new Mc()), this.sharedNodes.get(o).add(a);
      const u = a.options.initialPromotionConfig;
      a.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: o } = this.options;
      return o ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const u = this.getStack();
      u && u.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const u = {};
      l.z && ge("z", o, u, this.animationValues);
      for (let c = 0; c < pe.length; c++)
        ge(`rotate${pe[c]}`, o, u, this.animationValues), ge(`skew${pe[c]}`, o, u, this.animationValues);
      o.render();
      for (const c in u)
        o.setStaticValue(c, u[c]), this.animationValues && (this.animationValues[c] = u[c]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = $t(a == null ? void 0 : a.pointerEvents) || "", o.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = $t(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !it(this.latestValues) && (o.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const c = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = Vc(this.projectionDeltaWithTransform, this.treeScale, c);
      l && (h = l(c, h)), o.transform = h;
      const { x: f, y: d } = this.projectionDelta;
      o.transformOrigin = `${f.origin * 100}% ${d.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? c.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : c.opacityExit : o.opacity = u === this ? c.opacity !== void 0 ? c.opacity : "" : c.opacityExit !== void 0 ? c.opacityExit : 0;
      for (const p in It) {
        if (c[p] === void 0)
          continue;
        const { correct: y, applyTo: w, isCSSVariable: g } = It[p], x = h === "none" ? c[p] : y(c[p], u);
        if (w) {
          const v = w.length;
          for (let P = 0; P < v; P++)
            o[w[P]] = x;
        } else
          g ? this.options.visualElement.renderState.vars[p] = x : o[p] = x;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? $t(a == null ? void 0 : a.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var a;
        return (a = o.currentAnimation) == null ? void 0 : a.stop();
      }), this.root.nodes.forEach(Cs), this.root.sharedNodes.clear();
    }
  };
}
function Dc(t) {
  t.updateLayout();
}
function Ec(t) {
  var n;
  const e = ((n = t.resumeFrom) == null ? void 0 : n.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: s, measuredBox: i } = t.layout, { animationType: r } = t.options, o = e.source !== t.layout.source;
    r === "size" ? U((h) => {
      const f = o ? e.measuredBox[h] : e.layoutBox[h], d = F(f);
      f.min = s[h].min, f.max = f.min + d;
    }) : yo(r, e.layoutBox, s) && U((h) => {
      const f = o ? e.measuredBox[h] : e.layoutBox[h], d = F(s[h]);
      f.max = f.min + d, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[h].max = t.relativeTarget[h].min + d);
    });
    const a = gt();
    Dt(a, s, e.layoutBox);
    const l = gt();
    o ? Dt(l, t.applyTransform(i, !0), e.measuredBox) : Dt(l, s, e.layoutBox);
    const u = !fo(a);
    let c = !1;
    if (!t.resumeFrom) {
      const h = t.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: f, layout: d } = h;
        if (f && d) {
          const p = E();
          Et(p, e.layoutBox, f.layoutBox);
          const y = E();
          Et(y, s, d.layoutBox), mo(p, y) || (c = !0), h.options.layoutRoot && (t.relativeTarget = y, t.relativeTargetOrigin = p, t.relativeParent = h);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: s,
      snapshot: e,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (t.isLead()) {
    const { onExitComplete: s } = t.options;
    s && s();
  }
  t.options.transition = void 0;
}
function Rc(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function Lc(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function Bc(t) {
  t.clearSnapshot();
}
function Cs(t) {
  t.clearMeasurements();
}
function Ds(t) {
  t.isLayoutDirty = !1;
}
function kc(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Es(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function Ic(t) {
  t.resolveTargetDelta();
}
function Fc(t) {
  t.calcProjection();
}
function Oc(t) {
  t.resetSkewAndRotation();
}
function jc(t) {
  t.removeLeadSnapshot();
}
function Rs(t, e, n) {
  t.translate = D(e.translate, 0, n), t.scale = D(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Ls(t, e, n, s) {
  t.min = D(e.min, n.min, s), t.max = D(e.max, n.max, s);
}
function qc(t, e, n, s) {
  Ls(t.x, e.x, n.x, s), Ls(t.y, e.y, n.y, s);
}
function Nc(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const zc = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Bs = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), ks = Bs("applewebkit/") && !Bs("chrome/") ? Math.round : _;
function Is(t) {
  t.min = ks(t.min), t.max = ks(t.max);
}
function Hc(t) {
  Is(t.x), Is(t.y);
}
function yo(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !Gl(Vs(e), Vs(n), 0.2);
}
function Uc(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const _c = go({
  attachResizeListener: (t, e) => Ft(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), ye = {
  current: void 0
}, vo = go({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!ye.current) {
      const t = new _c({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), ye.current = t;
    }
    return ye.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Wc = {
  pan: {
    Feature: cc
  },
  drag: {
    Feature: lc,
    ProjectionNode: vo,
    MeasureLayout: co
  }
};
function Fs(t, e, n) {
  const { props: s } = t;
  t.animationState && s.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, r = s[i];
  r && A.postRender(() => r(e, Nt(e)));
}
class Kc extends et {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = va(e, (n, s) => (Fs(this.node, s, "Start"), (i) => Fs(this.node, i, "End"))));
  }
  unmount() {
  }
}
class $c extends et {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ot(Ft(this.node.current, "focus", () => this.onFocus()), Ft(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Os(t, e, n) {
  const { props: s } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && s.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), r = s[i];
  r && A.postRender(() => r(e, Nt(e)));
}
class Gc extends et {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = Sa(e, (n, s) => (Os(this.node, s, "Start"), (i, { success: r }) => Os(this.node, i, r ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Ne = /* @__PURE__ */ new WeakMap(), ve = /* @__PURE__ */ new WeakMap(), Zc = (t) => {
  const e = Ne.get(t.target);
  e && e(t);
}, Yc = (t) => {
  t.forEach(Zc);
};
function Xc({ root: t, ...e }) {
  const n = t || document;
  ve.has(n) || ve.set(n, {});
  const s = ve.get(n), i = JSON.stringify(e);
  return s[i] || (s[i] = new IntersectionObserver(Yc, { root: t, ...e })), s[i];
}
function Jc(t, e, n) {
  const s = Xc(e);
  return Ne.set(t, n), s.observe(t), () => {
    Ne.delete(t), s.unobserve(t);
  };
}
const Qc = {
  some: 0,
  all: 1
};
class t1 extends et {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: s, amount: i = "some", once: r } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: s,
      threshold: typeof i == "number" ? i : Qc[i]
    }, a = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, r && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: h } = this.node.getProps(), f = u ? c : h;
      f && f(l);
    };
    return Jc(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(e1(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function e1({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const n1 = {
  inView: {
    Feature: t1
  },
  tap: {
    Feature: Gc
  },
  focus: {
    Feature: $c
  },
  hover: {
    Feature: Kc
  }
}, s1 = {
  layout: {
    ProjectionNode: vo,
    MeasureLayout: co
  }
}, i1 = {
  ...Hl,
  ...n1,
  ...Wc,
  ...s1
}, js = /* @__PURE__ */ il(i1, yl), m1 = (t) => /* @__PURE__ */ m(
  js.svg,
  {
    viewBox: "25 25 50 50",
    width: "24px",
    height: "24px",
    style: { display: "block", zIndex: 1 },
    strokeWidth: "3",
    stroke: "black",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    opacity: "0",
    animate: { opacity: 1 },
    transition: { duration: 0.5, ease: "easeIn" },
    ...t,
    children: /* @__PURE__ */ m(
      js.circle,
      {
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        strokeDasharray: "1, 200",
        strokeDashoffset: "0",
        animate: {
          strokeDasharray: ["1 200", "89 200", "89 200"],
          rotate: 360,
          strokeDashoffset: [0, -35, -124]
        },
        transition: {
          type: "tween",
          ease: "linear",
          duration: 1.3,
          repeat: 1 / 0,
          repeatType: "loop"
        }
      }
    )
  }
), p1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 5",
    height: "100%",
    width: "100%",
    ...t,
    children: /* @__PURE__ */ m(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.105283 2.68526C-0.0350944 2.55533 -0.0350944 2.34467 0.105283 2.21474L2.39287 0.097446C2.53325 -0.032482 2.76084 -0.032482 2.90122 0.097446C3.0416 0.227374 3.0416 0.438029 2.90122 0.567957L1.22727 2.1173H12.6V2.7827H1.22727L2.90122 4.33204C3.0416 4.46197 3.0416 4.67263 2.90122 4.80255C2.76084 4.93248 2.53325 4.93248 2.39287 4.80255L0.105283 2.68526Z",
        fill: "currentColor"
      }
    )
  }
), g1 = (t) => /* @__PURE__ */ M("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 13", ...t, children: [
  /* @__PURE__ */ m("rect", { width: "20", height: "1" }),
  /* @__PURE__ */ m("rect", { y: "6", width: "20", height: "1" }),
  /* @__PURE__ */ m("rect", { y: "12", width: "20", height: "1" })
] }), y1 = (t) => /* @__PURE__ */ M("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 18", ...t, children: [
  /* @__PURE__ */ m("path", { d: "M0,0v18h16V0H0ZM15,17H1V1h14v16Z" }),
  /* @__PURE__ */ m("path", { d: "M8,7.6c3,0,3.7-2.3,3.9-3.8h-1c-.1.6-.3,1.4-.9,2-.5.5-1.2.8-2.1.8s-1.6-.3-2.1-.8c-.5-.6-.8-1.3-.9-2h-1c.3,1.4,1.1,3.8,4.1,3.8Z" })
] }), v1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.42 100.17",
    height: "100%",
    width: "100%",
    ...t,
    children: /* @__PURE__ */ m("path", { d: "M53.03,76.6L129.64,0l11.78,11.79L53.03,100.17,0,47.14l11.79-11.78,41.25,41.25Z" })
  }
), w1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.7 8.7",
    height: "100%",
    width: "100%",
    ...t,
    children: /* @__PURE__ */ m("polygon", { points: "8.7 .7 8 0 4.4 3.6 .7 0 0 .7 3.6 4.4 0 8 .7 8.7 4.4 5.1 8 8.7 8.7 8 5.1 4.4 8.7 .7" })
  }
), x1 = (t) => /* @__PURE__ */ m("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...t, children: /* @__PURE__ */ m("path", { d: "M15,0H1C.45,0,0,.45,0,1v14c0,.55.45,1,1,1h14c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM15,15H1V1h14v14Z" }) }), T1 = (t) => /* @__PURE__ */ m("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...t, children: /* @__PURE__ */ m("rect", { width: "16", height: "16", rx: "1", ry: "1" }) }), S1 = (t) => /* @__PURE__ */ M("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...t, children: [
  /* @__PURE__ */ m("path", { d: "M15,9h-5c-.55,0-1,.45-1,1v5c0,.55.45,1,1,1h5c.55,0,1-.45,1-1v-5c0-.55-.45-1-1-1ZM15,15h-5v-5h5v5Z" }),
  /* @__PURE__ */ m("path", { d: "M6,9H1c-.55,0-1,.45-1,1v5c0,.55.45,1,1,1h5c.55,0,1-.45,1-1v-5c0-.55-.45-1-1-1ZM6,15H1v-5h5v5Z" }),
  /* @__PURE__ */ m("path", { d: "M15,0h-5c-.55,0-1,.45-1,1v5c0,.55.45,1,1,1h5c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM15,6h-5V1h5v5Z" }),
  /* @__PURE__ */ m("path", { d: "M6,0H1C.45,0,0,.45,0,1v5c0,.55.45,1,1,1h5c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM6,6H1V1h5v5Z" })
] }), b1 = (t) => /* @__PURE__ */ M("svg", { id: "a", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...t, children: [
  /* @__PURE__ */ m("rect", { x: "9", y: "9", width: "7", height: "7", rx: "1", ry: "1" }),
  /* @__PURE__ */ m("rect", { y: "9", width: "7", height: "7", rx: "1", ry: "1" }),
  /* @__PURE__ */ m("rect", { x: "9", width: "7", height: "7", rx: "1", ry: "1" }),
  /* @__PURE__ */ m("rect", { width: "7", height: "7", rx: "1", ry: "1" })
] }), P1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.5 137.5",
    ...t,
    children: /* @__PURE__ */ m("path", { d: "M150,0H12.5C5.6,0,0,5.6,0,12.5v112.5c0,6.9,5.6,12.5,12.5,12.5h137.5c6.9,0,12.5-5.6,12.5-12.5V12.5c0-6.9-5.6-12.5-12.5-12.5ZM150,12.5v80.27l-20.37-20.36c-4.88-4.88-12.8-4.88-17.68,0h0s-15.62,15.63-15.62,15.63l-34.38-34.38c-4.88-4.88-12.79-4.88-17.67,0l-31.78,31.78V12.5h137.5ZM12.5,103.12l40.62-40.62,62.5,62.5H12.5v-21.88ZM150,125h-16.7l-28.12-28.12,15.62-15.62,29.2,29.2v14.55ZM93.75,46.88c0-5.18,4.2-9.38,9.38-9.38s9.38,4.2,9.38,9.38-4.2,9.38-9.38,9.38-9.38-4.2-9.38-9.38Z" })
  }
), M1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 749.11 280",
    ...t,
    children: /* @__PURE__ */ m("path", { d: "M298.46 61.25v45.71h51.71v35.07l-51.71 27.87v47.8l55.74-29.48c7.62 21.1 25.45 30.52 48.21 30.52 30.3 0 52.76-16.98 52.76-56.42V61.25H298.46Zm116.23 95.34c0 10.71-3.13 16.45-12.28 16.45-9.66 0-12.54-5.75-12.54-16.45v-49.62h24.81v49.62ZM221.86 61.25H65.15v40.23h55.63v116.48h45.71V101.48h55.37V61.25zM519.42 217.96h50.93l30.03-53.54 30.04 53.54h53.54l-60.07-96.63V61.25h-45.71v60.08l-58.76 96.63z" })
  }
), V1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.7 18.8",
    ...t,
    children: /* @__PURE__ */ m("path", { d: "M14,13.3c1.2-1.4,2-3.3,2-5.3C16,3.6,12.4,0,8,0S0,3.6,0,8s3.6,8,8,8c2,0,3.9-.8,5.3-2l4.8,4.8.6-.8-4.7-4.7ZM8,15c-3.9,0-7-3.1-7-7S4.1,1,8,1s7,3.1,7,7-3.1,7-7,7Z" })
  }
), A1 = () => /* @__PURE__ */ M(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ m("defs", {}),
      /* @__PURE__ */ m("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), C1 = () => /* @__PURE__ */ M(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ m("defs", {}),
      /* @__PURE__ */ m("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), D1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 8.47",
    ...t,
    children: /* @__PURE__ */ m("path", { d: "M16.94,0H1.06C.47,0,0,.47,0,1.06v6.35c0,.59.47,1.06,1.06,1.06h15.88c.59,0,1.06-.47,1.06-1.06V1.06c0-.59-.47-1.06-1.06-1.06ZM16.94,7.41H1.06V1.06h3.17v2.44h1.06V1.06h3.17v3.18h1.06V1.06h3.17v2.44h1.06V1.06h3.17v6.35Z" })
  }
), E1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.67 166.67",
    ...t,
    children: [
      /* @__PURE__ */ m("polygon", { points: "104.92 50 83.33 71.58 61.75 50 50 61.75 71.58 83.33 50 104.92 61.75 116.67 83.33 95.08 104.92 116.67 116.67 104.92 95.08 83.33 116.67 61.75 104.92 50" }),
      /* @__PURE__ */ m("path", { d: "M83.33,0C37.25,0,0,37.25,0,83.33s37.25,83.33,83.33,83.33,83.33-37.25,83.33-83.33S129.42,0,83.33,0ZM83.33,150c-36.75,0-66.67-29.92-66.67-66.67S46.58,16.67,83.33,16.67s66.67,29.92,66.67,66.67-29.92,66.67-66.67,66.67Z" })
    ]
  }
), R1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.67 166.67",
    ...t,
    children: [
      /* @__PURE__ */ m("rect", { x: "75", y: "75", width: "16.67", height: "50" }),
      /* @__PURE__ */ m("path", { d: "M83.33,0C37.33,0,0,37.33,0,83.33s37.33,83.33,83.33,83.33,83.33-37.33,83.33-83.33S129.33,0,83.33,0ZM83.33,150c-36.75,0-66.67-29.92-66.67-66.67S46.58,16.67,83.33,16.67s66.67,29.92,66.67,66.67-29.92,66.67-66.67,66.67Z" }),
      /* @__PURE__ */ m("rect", { x: "75", y: "41.67", width: "16.67", height: "16.67" })
    ]
  }
), L1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.67 166.67",
    ...t,
    children: [
      /* @__PURE__ */ m("path", { d: "M83.33,0C37.33,0,0,37.33,0,83.33s37.33,83.33,83.33,83.33,83.33-37.33,83.33-83.33S129.33,0,83.33,0ZM83.33,150c-36.75,0-66.67-29.92-66.67-66.67S46.58,16.67,83.33,16.67s66.67,29.92,66.67,66.67-29.92,66.67-66.67,66.67Z" }),
      /* @__PURE__ */ m("polygon", { points: "121.58 46.5 66.67 101.42 45.08 79.92 33.33 91.67 66.67 125 133.33 58.33 121.58 46.5" })
    ]
  }
), B1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18.05",
    ...t,
    children: [
      /* @__PURE__ */ m("path", { d: "M8,11.05C1.4,11.05.2,15.85,0,18.05h1c.1-1.1.5-2.8,1.7-4.1,1.2-1.3,3-1.9,5.3-1.9s4.1.6,5.3,1.9c1.2,1.3,1.6,3,1.7,4.1h1c-.2-2.2-1.3-7-8-7Z" }),
      /* @__PURE__ */ m("path", { d: "M8,10.1c2.83,0,5.05-2.22,5.05-5.05S10.83,0,8,0,2.95,2.22,2.95,5.05s2.22,5.05,5.05,5.05ZM8,1c2.23,0,4.05,1.82,4.05,4.05s-1.78,4.05-4.05,4.05-4.05-1.78-4.05-4.05S5.77,1,8,1Z" })
    ]
  }
), k1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11.43",
    ...t,
    children: [
      /* @__PURE__ */ m("path", { d: "M15.43,4.57c.15,0,.3-.06.4-.17.11-.11.17-.25.17-.4V1.14c0-.3-.12-.59-.33-.81-.21-.21-.51-.33-.81-.33H1.14c-.3,0-.59.12-.81.33-.21.21-.33.51-.33.81v2.86c0,.15.06.3.17.4s.25.17.4.17c.3,0,.59.12.81.33s.33.51.33.81-.12.59-.33.81-.51.33-.81.33c-.15,0-.3.06-.4.17-.11.11-.17.25-.17.4v2.86c0,.3.12.59.33.81.21.21.51.33.81.33h13.71c.3,0,.59-.12.81-.33.21-.21.33-.51.33-.81v-2.86c0-.15-.06-.3-.17-.4-.11-.11-.25-.17-.4-.17-.3,0-.59-.12-.81-.33s-.33-.51-.33-.81.12-.59.33-.81.51-.33.81-.33ZM13.63,7.11c.31.4.74.69,1.23.81v2.36h-4v-1.71h-1.14v1.71H1.14v-2.36c.49-.13.92-.41,1.23-.81s.48-.89.48-1.4-.17-1-.48-1.4-.74-.69-1.23-.81V1.14h8.57v1.71h1.14v-1.71h4v2.36c-.49.13-.92.41-1.23.81-.31.4-.48.89-.48,1.4s.17,1,.48,1.4Z" }),
      /* @__PURE__ */ m("rect", { x: "9.71", y: "4", width: "1.14", height: "3.43" })
    ]
  }
), I1 = (t) => /* @__PURE__ */ m(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-13.351 -7.125 115.705 42.753",
    ...t,
    children: /* @__PURE__ */ m(
      "path",
      {
        fillRule: "evenodd",
        d: "M85.504 28v-3c-.912 1.881-3.063 3-5.5 3-4.15 0-7-3.268-7-8.5 0-5.217 2.85-8.5 7-8.5 2.389 0 4.62 1.65 5.5 3.5V5h3.5v23zm-4.5-14c-2.484 0-4.5 2.259-4.5 5.5 0 3.256 2.023 5.556 4.506 5.556 2.468 0 4.494-2.331 4.494-5.556 0-3.209-2.032-5.5-4.5-5.5m-13.5 4v10h-4V11h4v3.291h.079C68.118 12.315 69.539 11 71.504 11c.503 0 .701-.079 1 0v3.5h-1.5c-2.217 0-3.5 1.129-3.5 3.5m-10 10v-3c-.918 1.812-3.323 3-5.5 3-3.235 0-5.504-1.585-5.504-4.616s2.271-4.779 6.423-5.035L57.504 18v-1c0-1.781-1.511-3.029-3.5-3.023-1.68.006-2.751.676-3 2.023h-3.5c.109-3.127 2.729-4.996 6.664-4.996 4.137 0 6.843 2.213 6.843 5.597L61.004 28zm0-7.5h-4c-2.022.144-3.5 1.137-3.5 2.5 0 1.347 1.504 2.485 3.23 2.485 2.224 0 4.27-1.464 4.27-3.485zm-22.073 4.54c3.002 0 4.944-1.789 5.573-4.54h4c-.707 4.885-4.139 7.5-9.5 7.5-6.477 0-10.5-4.181-10.5-11.5 0-7.272 4.055-11.5 10.5-11.5 5.266 0 8.997 3.1 9.5 8h-4c-.534-2.861-2.56-5-5.5-5-3.899 0-7 3.41-7 8.5 0 5.122 2.997 8.54 6.927 8.54M16.76 28.502c-1.84 0-2.5-1.17-4.622-1.17-2.28 0-2.924 1.17-4.669 1.17-1.934 0-3.301-1.866-4.512-3.604-1.572-2.277-2.908-5.849-2.955-9.28-.032-1.818.314-3.604 1.195-5.121C2.438 8.378 4.655 6.94 7.076 6.893c1.855-.064 3.506 1.28 4.637 1.28 1.085 0 3.113-1.28 5.408-1.28.991 0 3.248.078 4.883 2.607-.126.079-2.745 1.977-2.745 5.692.142 4.236 3.682 5.308 3.745 5.308-.063.079-.444 2.437-1.89 4.477-1.147 1.754-2.421 3.525-4.354 3.525M11.504 6.5c-.33-1.66.651-3.441 1.5-4.5 1.085-1.28 3.022-2 4.5-2 .094 1.66-.931 3.314-2 4.5-.959 1.28-2.475 2.19-4 2"
      }
    )
  }
), F1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 1",
    viewBox: "0 0 1200 600",
    ...t,
    children: [
      /* @__PURE__ */ m(
        "path",
        {
          d: "M0 0h1200v600H0z",
          style: {
            fill: "#41cda5"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M261.76 375.88c-23 0-39.3-18.81-39.3-41.62s16.3-41.7 39.3-41.7c25.79 0 39.3 18.81 39.3 41.7s-13.51 41.62-39.3 41.62m1.39-107.52c-13.26 0-27.1 5.39-35.28 13.41l-1.39 1.3-1.64 1.8V200H198v197.38h26.85v-14.06l1.64 2 1.39 1.31c8.1 8.1 21.69 13.41 35.28 13.41 35.29 0 65.09-26.9 65.09-65.82s-29.9-65.86-65.1-65.86m162.67 79.23A30 30 0 0 1 396 375.8c-18.17 0-26.61-9.65-27.1-26.9V271h-27.07v77.9c0 29.6 19 51.1 51.49 51.1 10.81 0 24.4-5.4 29.8-13.41l1.39-1.8 1.39-1.8v14.39H453V271.05h-27.1v76.54Zm348.42-30.34c4.09-14 14.9-24.69 33.89-24.69 16.3 0 29.81 10.71 31.17 24.69Zm33.89-48.89c-35.28 0-62.38 26.9-62.38 65.82S774.24 400 808.13 400c25.78 0 44.68-13.41 55.6-32.22l-22.79-10.71c-4.09 10.71-15.14 18.81-31.38 18.81-23.12 0-36.63-16.11-36.63-34.92h94.89v-8.09c-.07-39-27.15-64.51-59.69-64.51m100.28 48.89c4.1-14 14.94-24.69 33.91-24.69 16.3 0 29.81 10.71 31.18 24.69Zm33.91-48.89c-35.27 0-62.36 26.9-62.36 65.82S908.41 400 942.32 400c25.79 0 44.68-13.41 55.6-32.22l-22.79-10.71c-4.13 10.71-15.13 18.81-31.45 18.81-23 0-36.56-16.11-36.56-34.92H1002v-8.09c-.06-39-27.21-64.51-59.68-64.51M671.17 375.88c-23 0-39.29-18.81-39.29-41.62s16.29-41.7 39.29-41.7c25.79 0 39.3 18.81 39.3 41.7s-13.47 41.62-39.3 41.62m1.39-107.52c-13.26 0-27.09 5.39-35.28 13.41l-1.39 1.3-1.64 1.8V200H607.4v197.38h26.85v-14.06l1.64 2 1.39 1.31c8.1 8.1 21.69 13.41 35.28 13.41 35.29 0 65.09-26.9 65.09-65.82s-29.88-65.86-65.09-65.86M490.9 334.18c0-22.81 13.59-41.7 39.3-41.7 23 0 39.29 18.8 39.29 41.7S553.2 375.8 530.2 375.8c-25.79.08-39.3-18.73-39.3-41.62m-27.09 0c0 39 29.79 65.82 65.08 65.82 13.59 0 27.1-5.4 35.28-13.41l1.4-1.31 1.63-2v14.06h26.85V200H567v84.87l-1.64-1.8-1.39-1.3c-8.11-8.1-21.94-13.41-35.28-13.41-35.09 0-64.88 26.82-64.88 65.82",
          style: {
            fill: "#fff"
          }
        }
      )
    ]
  }
), O1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-24.164 -8.964 209.421 53.784",
    ...t,
    children: [
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#003662",
          d: "M71.28 21.912H60.712v2.425h.347c.086-.346.693-1.04 1.472-1.04h2.338v12.386h2.339V23.298h2.425c.78 0 1.3.433 1.386.866v.087h.346zm-68.855-.78C.866 22.693 0 24.944 0 27.11c0 2.511 1.04 4.763 2.772 6.322s4.07 2.425 6.495 2.425c1.3 0 3.811-.26 6.323-1.732l.086-.087.26-3.464-.433-.087-.086.174c-1.82 3.724-4.59 3.724-5.717 3.724-4.763 0-6.928-3.984-6.928-7.622 0-3.55 2.165-7.188 6.928-7.188 1.473 0 4.158.52 5.543 3.724l.087.173.433-.173-.173-3.551-.087-.087c-2.252-.952-4.07-1.385-5.89-1.385-2.944.086-5.456 1.039-7.188 2.858zm15.85.78-.087.347c.173.086.433.606.433 1.212v12.125h2.252v-6.235h.953c.866.086 1.212.606 1.732 1.385l.086.087.26.52c.52.78 1.126 1.905 1.819 2.944.52.78 1.126 1.126 1.905 1.3.52.086 1.646.086 2.079-.087l.52-.087.173-.086-.693-.174c-.26-.086-.693-.26-1.3-.952-.346-.433-.952-1.386-1.818-2.772l-.866-1.385c-.26-.347-.606-.867-1.3-1.3 1.3-.433 2.512-1.559 2.512-3.29 0-.52-.086-1.473-.952-2.253S23.818 22 21.999 22zm3.897 1.3c2.338.086 2.425 2.078 2.425 2.338 0 1.992-1.472 2.685-2.685 2.685h-.952v-4.937c.26-.087.692-.173 1.212-.087zm19.4-1.3v.347c.174.086.347.606.347 1.039v12.299h3.897c2.599 0 4.677-.78 6.15-2.339 1.212-1.3 1.905-2.945 1.905-4.764 0-1.039-.346-2.684-1.386-3.984-1.385-1.732-3.464-2.685-6.322-2.685zm2.685 1.386h1.213c.346 0 1.126 0 1.732.087 3.81.606 4.244 3.81 4.244 5.196 0 1.126-.173 2.685-1.126 3.984q-1.43 1.82-4.417 1.819h-1.646zm14.378-1.386H55.95v.347c.26.086.433.606.433 1.126v12.211h2.252zm45.903 0h-2.685v.347c.26.086.433.606.433 1.126v12.211h2.252zm-65.91 0h-7.622l.087.347c.173.086.433.606.433 1.212v12.125h7.621l.52-2.425-.346-.086-.087.173c-.606.953-1.3 1.126-3.464 1.126-.78 0-1.56-.087-2.079-.087v-5.543h3.898v-1.299H33.69v-4.244h3.118c.693 0 1.472.693 1.559 1.126v.087h.346zm97.695 0h-7.621v.347c.173.086.433.52.433 1.212v12.125h7.621l.52-2.425-.347-.086-.086.173c-.606.953-1.3 1.126-3.465 1.126-.779 0-1.559-.087-2.078-.087v-5.543h3.897v-1.299H131.3v-4.244h3.118c.866 0 1.472.693 1.472 1.126v.087h.347zM77.948 19.4c-.779.607-1.732 1.646-1.818 3.465v.087c0 2.165 1.385 3.377 3.637 4.503.087.087.26.173.866.433 1.906.953 3.205 1.646 3.205 3.551 0 .693-.26 1.646-.953 2.339-.606.606-1.386.866-2.338.866-2.858 0-3.898-2.512-4.157-3.638l-.087-.173-.52.086.173 3.551.26-.086c.953.52 2.425 1.386 4.677 1.472 1.56 0 3.118-.606 4.244-1.732.953-.953 1.472-2.165 1.472-3.464 0-2.858-2.078-3.984-4.243-5.11l-.433-.26c-2.252-1.126-3.292-1.819-3.292-3.205 0-.952.78-2.511 2.685-2.511 2.252 0 3.465 1.732 3.724 2.771l.087.173.52-.086-.173-3.118-.087-.087c-1.3-.866-2.945-1.039-3.638-1.039-1.559.087-2.858.52-3.81 1.212zm30.314 5.976c0 1.906 1.126 2.859 2.944 3.811l.693.347c1.473.693 2.425 1.212 2.425 2.598 0 .26-.086 1.04-.692 1.732-.433.433-1.04.693-1.82.606-2.164 0-2.944-1.732-3.29-2.684l-.087-.174-.433.087.087 2.858.086.087c.693.433 1.906 1.126 3.724 1.126 1.213 0 2.512-.52 3.378-1.386.78-.78 1.126-1.732 1.126-2.772 0-2.425-1.646-3.29-3.378-4.157l-.346-.173c-1.906-.953-2.512-1.386-2.512-2.425 0-.78.52-1.819 2.079-1.819 1.819 0 2.598 1.386 2.771 2.079l.087.173.433-.087-.173-2.511-.087-.087c-1.04-.693-2.338-.78-2.858-.78-1.992 0-4.157 1.213-4.157 3.552zm10.22 0c0 1.906 1.126 2.859 2.944 3.811l.693.347c1.473.693 2.425 1.212 2.425 2.598 0 .26-.086 1.04-.693 1.732-.433.433-1.039.693-1.818.606-2.166 0-2.945-1.732-3.291-2.684l-.087-.174-.433.087.086 2.858.087.087c.693.433 1.905 1.126 3.724 1.126 1.213 0 2.512-.52 3.378-1.386.78-.78 1.126-1.732 1.126-2.772 0-2.425-1.646-3.29-3.378-4.157l-.346-.173c-1.906-.953-2.512-1.386-2.512-2.425 0-.433.173-.953.52-1.3.346-.346.866-.519 1.472-.519 1.819 0 2.598 1.386 2.772 2.079l.086.173.433-.087-.173-2.511-.087-.087c-1.039-.693-2.338-.78-2.858-.78-1.818 0-4.07 1.213-4.07 3.552zm-19.574-3.464h-1.819v.347c.087.086.346.26.346 1.126v7.794c0 1.473-.52 3.292-3.204 3.292-2.512 0-3.031-1.473-3.031-3.725v-8.834h-2.858v.347c.173.086.52.433.52 1.212v7.275c0 4.504 2.944 5.024 5.196 5.024 1.126 0 4.677-.347 4.677-4.59zm57.075-3.897a25.6 25.6 0 0 1 5.11 2.252C156.677 12.99 148.882 5.11 141.173 0c1.992 1.992 5.197 6.322 6.063 10.913a104 104 0 0 1 8.748 7.102z"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#003662",
          d: "M155.983 18.015c-3.81-1.213-7.015-1.3-9.353-1.04.866-1.992.952-4.07.606-6.062-5.803-4.157-12.299-7.795-18.448-10.48 4.504 3.031 9.527 11.952 11.606 21.48 4.503-1.3 11.346-2.253 20.266.779a119 119 0 0 0-4.676-4.677z"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "none",
          d: "M147.15 10.913c.346 1.992.26 4.07-.52 6.062 2.425-.26 5.63-.173 9.354 1.04-2.685-2.425-5.63-4.85-8.835-7.102z"
        }
      )
    ]
  }
), j1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "dhl_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 143.5 20",
    ...t,
    children: [
      /* @__PURE__ */ m("style", { children: ".dhl_svg__st0{fill:#d40511}" }),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M0 18.5h17.4l-1 1.4H0zm143.5 1.4h-21.3l1.1-1.4h20.3v1.4zM0 15.9h19.4l-1.1 1.4H0zm0-2.6h21.4l-1.1 1.4H0zm143.5 4h-19.3l1.1-1.4h18.3v1.4zm-16.3-4h16.3v1.4h-17.4zM18.8 19.9 28 7.6h11.4c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.5-.9 1.2 1 1.2H54C52.8 15 48.6 20 41.2 20c-6-.1-22.4-.1-22.4-.1m52.7-6.6-5 6.7H53.4l5-6.7zm19.1 0-5 6.7H72.4l5-6.7zm4.3 0s-1 1.3-1.4 1.9c-1.7 2.2-.2 4.8 5.2 4.8h21.2l5-6.7z",
          className: "dhl_svg__st0"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "m25.3 0-4.6 6.1h25c1.3 0 1.3.5.6 1.3-.6.8-1.7 2.3-2.3 3.1-.3.4-.9 1.2 1 1.2h10.2s1.7-2.2 3-4.1c1.9-2.5.2-7.7-6.5-7.7-6 .1-26.4.1-26.4.1m66.4 11.7H59.5L68.3 0h13.2l-5 6.7h5.9l5-6.7h13.2zM118.8 0 110 11.7H96L104.8 0z",
          className: "dhl_svg__st0"
        }
      )
    ]
  }
), q1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 80 38.1",
    ...t,
    children: [
      /* @__PURE__ */ m(
        "path",
        {
          d: "M37.8 19.7V29h-3V6h7.8c1.9 0 3.7.7 5.1 2 1.4 1.2 2.1 3 2.1 4.9s-.7 3.6-2.1 4.9-3.1 2-5.1 2zm0-10.9v8h5c1.1 0 2.2-.4 2.9-1.2 1.6-1.5 1.6-4 .1-5.5l-.1-.1c-.8-.8-1.8-1.3-2.9-1.2zm18.9 4c2.2 0 3.9.6 5.2 1.8s1.9 2.8 1.9 4.8V29H61v-2.2h-.1c-1.2 1.8-2.9 2.7-4.9 2.7-1.7 0-3.2-.5-4.4-1.5-1.1-1-1.8-2.4-1.8-3.9q0-2.4 1.8-3.9c1.2-1 2.9-1.4 4.9-1.4 1.8 0 3.2.3 4.3 1v-.7c0-1-.4-2-1.2-2.6-.8-.7-1.8-1.1-2.9-1.1q-2.55 0-3.9 2.1l-2.6-1.6c1.6-2.1 3.7-3.1 6.5-3.1m-3.8 11.4c0 .8.4 1.5 1 1.9.7.5 1.5.8 2.3.8 1.2 0 2.4-.5 3.3-1.4 1-.9 1.5-2 1.5-3.2-.9-.7-2.2-1.1-3.9-1.1q-1.8 0-3 .9-1.2.75-1.2 2.1M80 13.3 70.1 36h-3l3.7-7.9-6.5-14.7h3.2l4.7 11.3h.1l4.6-11.3H80z",
          style: {
            fill: "#5f6368"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M25.9 17.7c0-.9-.1-1.8-.2-2.7H13.2v5.1h7.1c-.3 1.6-1.2 3.1-2.6 4v3.3H22c2.5-2.3 3.9-5.7 3.9-9.7",
          style: {
            fill: "#4285f4"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M13.2 30.6c3.6 0 6.6-1.2 8.8-3.2l-4.3-3.3c-1.2.8-2.7 1.3-4.5 1.3-3.4 0-6.4-2.3-7.4-5.5H1.4v3.4c2.3 4.5 6.8 7.3 11.8 7.3",
          style: {
            fill: "#34a853"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M5.8 19.9c-.6-1.6-.6-3.4 0-5.1v-3.4H1.4c-1.9 3.7-1.9 8.1 0 11.9z",
          style: {
            fill: "#fbbc04"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M13.2 9.4c1.9 0 3.7.7 5.1 2l3.8-3.8c-2.4-2.2-5.6-3.5-8.8-3.4-5 0-9.6 2.8-11.8 7.3l4.4 3.4c.9-3.2 3.9-5.5 7.3-5.5",
          style: {
            fill: "#ea4335"
          }
        }
      )
    ]
  }
), N1 = (t) => /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 278 85", ...t, children: /* @__PURE__ */ M("g", { fill: "none", children: [
  /* @__PURE__ */ m(
    "path",
    {
      fill: "#FF3E3E",
      d: "M13.203.23h251.362c4.457 0 6.074.465 7.703 1.336a9.1 9.1 0 0 1 3.78 3.78c.872 1.63 1.336 3.247 1.336 7.704v58.361c0 4.458-.464 6.074-1.336 7.704a9.1 9.1 0 0 1-3.78 3.78c-1.63.872-3.246 1.336-7.703 1.336H13.203c-4.457 0-6.074-.464-7.703-1.336a9.1 9.1 0 0 1-3.78-3.78C.848 77.485.384 75.869.384 71.41V13.05c0-4.458.464-6.075 1.336-7.705a9.1 9.1 0 0 1 3.78-3.78C7.13.695 8.746.231 13.203.231Z"
    }
  ),
  /* @__PURE__ */ M("g", { fill: "#FFF", children: [
    /* @__PURE__ */ m("path", { d: "m249.043 46.24 11.341 16.702h-12.202l-5.527-8.496-5.528 8.496h-11.628l11.269-16.628-10.767-16.047h12.131l5.024 7.842 5.097-7.842h11.628z" }),
    /* @__PURE__ */ m("path", { d: "M209.946 38.685c-3.429 0-5.356 3.167-5.356 7.63s1.927 7.558 5.356 7.558c3.499 0 5.427-3.095 5.427-7.558s-1.928-7.63-5.427-7.63m0 24.546c-9.713 0-16.426-6.91-16.426-16.916s6.713-16.916 16.426-16.916c9.783 0 16.425 6.91 16.425 16.916s-6.642 16.916-16.425 16.916m-40.894-12.723c.862 1.807 2.731 3.036 4.961 3.036 3.882 0 6.183-3.109 6.183-7.301s-2.3-7.374-6.183-7.374c-2.157 0-4.099 1.301-4.961 3.036zm0 12h-11.29V15.52h11.29v17.06c1.51-1.735 4.673-3.325 7.98-3.325 9.348 0 14.453 7.59 14.453 16.988s-5.105 16.988-14.452 16.988c-3.308 0-6.472-1.59-7.981-3.325zm-27.05-10.843c-.716-1.374-2.508-2.241-4.514-2.241-2.22 0-4.442.94-4.442 3.108 0 2.241 2.221 3.18 4.442 3.18 2.006 0 3.798-.867 4.514-2.168zm0-8.603c0-2.53-2.292-4.337-6.878-4.337-3.08 0-6.233.795-8.813 2.313V31.93c2.652-1.446 6.95-2.53 11.535-2.53 9.529 0 14.975 4.554 14.975 13.156v20.096H142V60.99c-1.073 1.084-4.155 2.24-7.593 2.24-6.377 0-11.821-3.614-11.821-10.481 0-6.29 5.444-10.337 12.393-10.337 2.723 0 5.732.867 7.022 1.807v-1.157Zm-25.983 19.88h-11.126V39.149H99.33v-8.85h5.563v-8.996h11.126v8.996h6.277v8.85h-6.277zM72.146 50.634c3.065 2.52 8.056 4.103 11.336 4.103 2.21 0 3.635-.504 3.635-1.943 0-1.296-.998-1.8-2.923-2.232l-2.495-.647c-5.917-1.297-9.696-4.104-9.696-9.934 0-6.766 5.56-10.582 13.117-10.582 4.564 0 8.057.937 11.193 2.88v9.286c-3.065-2.232-6.487-3.744-10.123-3.744-1.924 0-3.208.648-3.208 1.944 0 1.223.926 1.655 2.495 2.087l2.923.864c6.987 1.872 9.767 4.751 9.767 10.221 0 6.91-5.918 10.294-13.83 10.294-4.491 0-9.196-1.08-12.191-3.095zM36.827 30.123h11.28v2.82c1.796-2.025 4.957-3.544 8.693-3.544 7.185 0 11.424 4.7 11.424 11.928v21.325H57.015V44.074c0-2.674-1.364-4.626-4.238-4.626-2.228 0-4.096 1.301-4.67 3.542v19.662h-11.28v-32.53m-16.724 32.53h11.28v-32.48h-11.28zm5.676-35.223c-3.45 0-6.395-2.382-6.395-6.063 0-3.753 2.945-6.135 6.395-6.135s6.396 2.382 6.396 6.135c0 3.681-2.947 6.063-6.396 6.063" })
  ] })
] }) }), z1 = (t) => /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 444.75", ...t, children: /* @__PURE__ */ M("g", { fillRule: "evenodd", transform: "translate(.236 .3)scale(17.769)", children: [
  /* @__PURE__ */ m("rect", { width: 45, height: 25, fill: "#ffb3c7", rx: 4.321 }),
  /* @__PURE__ */ m(
    "path",
    {
      fill: "#0a0b09",
      d: "M40.787 14.674a1.07 1.07 0 0 0-1.066 1.076 1.07 1.07 0 0 0 1.066 1.075 1.07 1.07 0 0 0 1.066-1.075 1.07 1.07 0 0 0-1.066-1.076m-3.507-.832c0-.813-.69-1.472-1.54-1.472s-1.538.659-1.538 1.472c0 .814.689 1.473 1.539 1.473s1.539-.66 1.539-1.473m.005-2.862h1.699v5.724h-1.699v-.365a2.96 2.96 0 0 1-1.683.524c-1.653 0-2.994-1.352-2.994-3.02s1.34-3.021 2.994-3.021c.624 0 1.204.194 1.683.524zm-13.592.746v-.746h-1.739v5.724h1.743v-2.672c0-.902.969-1.386 1.64-1.386h.021v-1.665c-.69 0-1.324.298-1.665.745m-4.331 2.116c0-.813-.69-1.472-1.54-1.472s-1.538.659-1.538 1.472c0 .814.689 1.473 1.539 1.473s1.539-.66 1.539-1.473m.005-2.862h1.699v5.724h-1.699v-.365a2.96 2.96 0 0 1-1.683.524c-1.653 0-2.994-1.352-2.994-3.02s1.34-3.021 2.994-3.021c.624 0 1.204.194 1.683.524zm10.223-.154c-.678 0-1.32.213-1.75.8v-.645h-1.69v5.723h1.711v-3.008c0-.87.579-1.296 1.275-1.296.747 0 1.176.45 1.176 1.284v3.02h1.696v-3.64c0-1.332-1.05-2.238-2.418-2.238m-17.374 5.878h1.778V8.43h-1.778zm-7.809.003H6.29v-8.28H4.407zm6.584-8.28a6.62 6.62 0 0 1-1.925 4.7l2.602 3.58H9.343l-2.828-3.891.73-.552a4.77 4.77 0 0 0 1.904-3.836h1.842z"
    }
  )
] }) }), H1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.209,
    height: 144,
    viewBox: "0 0 152.407 108",
    ...t,
    children: [
      /* @__PURE__ */ m(
        "path",
        {
          d: "M0 0h152.407v108H0z",
          style: {
            fill: "none"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M60.412 25.697h31.5v56.606h-31.5z",
          style: {
            fill: "#ff5f00"
          }
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M382.208 306a35.94 35.94 0 0 1 13.75-28.303 36 36 0 1 0 0 56.606A35.94 35.94 0 0 1 382.208 306",
          style: {
            fill: "#eb001b"
          },
          transform: "translate(-319.796 -252)"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          d: "M454.203 306a35.999 35.999 0 0 1-58.245 28.303 36.005 36.005 0 0 0 0-56.606A35.999 35.999 0 0 1 454.203 306m-3.434 22.308v-1.16h.467v-.235h-1.19v.236h.468v1.159Zm2.31 0v-1.398h-.364l-.42.962-.42-.962h-.365v1.398h.258v-1.054l.393.908h.267l.394-.91v1.056Z",
          style: {
            fill: "#f79e1b"
          },
          transform: "translate(-319.796 -252)"
        }
      )
    ]
  }
), U1 = (t) => /* @__PURE__ */ M(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 -140 780 780",
    ...t,
    children: [
      /* @__PURE__ */ m("path", { fill: "#FFF", d: "M0 0h780v500H0z" }),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#003087",
          d: "M168.38 169.85c-8.399-5.774-19.359-8.668-32.88-8.668H83.154q-6.218.001-6.87 6.214l-21.265 133.48q-.33 1.966.981 3.6c.869 1.093 1.962 1.636 3.271 1.636h24.864c4.361 0 6.758-2.068 7.198-6.216l5.888-35.985c.215-1.744.982-3.162 2.291-4.254 1.308-1.09 2.944-1.804 4.907-2.13 1.963-.324 3.814-.487 5.562-.487q2.614 0 6.217.327 3.597.325 4.58.324c18.756 0 33.478-5.285 44.167-15.866 10.684-10.577 16.032-25.244 16.032-44.004 0-12.868-4.202-22.192-12.597-27.975zm-26.99 40.08c-1.094 7.635-3.926 12.649-8.506 15.049-4.581 2.403-11.124 3.597-19.629 3.597l-10.797.328 5.563-35.007q.65-3.596 4.252-3.597h6.218c8.72 0 15.049 1.257 18.975 3.761q5.887 3.767 3.924 15.869"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#009CDE",
          d: "M720.79 161.18h-24.208q-3.606 0-4.253 3.599l-21.267 136.1-.328.654c0 1.096.437 2.127 1.311 3.109.868.979 1.963 1.471 3.271 1.471h21.595c4.138 0 6.429-2.068 6.871-6.215l21.265-133.81v-.325c-.002-3.053-1.424-4.58-4.257-4.58z"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#003087",
          d: "M428.31 213.86c0-1.088-.438-2.126-1.306-3.106q-1.313-1.473-2.945-1.474h-25.191c-2.404 0-4.366 1.096-5.89 3.271l-34.679 51.04-14.394-49.075q-1.642-5.234-7.198-5.236h-24.54q-1.64 0-2.942 1.474c-.875.98-1.309 2.019-1.309 3.106 0 .44 2.127 6.871 6.379 19.303q6.379 18.65 13.741 40.244c4.908 14.394 7.468 22.031 7.688 22.898q-26.827 36.646-26.826 39.26 0 4.256 4.253 4.254h25.191q3.597.002 5.89-3.271l83.427-120.4c.433-.433.651-1.193.651-2.289z"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#009CDE",
          d: "M662.89 209.28h-24.865c-3.056 0-4.904 3.599-5.559 10.797-5.677-8.72-16.031-13.088-31.083-13.088q-23.558 0-40.077 17.668-16.522 17.67-16.521 41.551 0 19.306 11.285 30.752c7.524 7.639 17.611 11.451 30.266 11.451q9.485-.002 19.3-3.926c6.544-2.617 11.665-6.105 15.379-10.469 0 .219-.222 1.198-.654 2.942-.44 1.748-.655 3.06-.655 3.926 0 3.494 1.414 5.234 4.254 5.234h22.576c4.138 0 6.541-2.068 7.193-6.216l13.415-85.389q.323-1.962-.981-3.599c-.876-1.087-1.964-1.634-3.273-1.634m-42.694 64.452q-8.343 8.18-20.12 8.179c-6.328 0-11.449-1.742-15.377-5.234q-5.891-5.225-5.891-14.396c0-8.064 2.727-14.884 8.181-20.446 5.446-5.562 12.214-8.343 20.284-8.343q9.154 0 15.212 5.397c4.032 3.599 6.055 8.563 6.055 14.888q-.002 11.778-8.344 19.955"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#003087",
          d: "M291.23 209.28h-24.864c-3.058 0-4.908 3.599-5.563 10.797-5.889-8.72-16.25-13.088-31.081-13.088q-23.557 0-40.078 17.668-16.522 17.67-16.521 41.551 0 19.306 11.288 30.752c7.525 7.639 17.61 11.451 30.262 11.451 6.104 0 12.433-1.311 18.975-3.926q9.815-3.924 15.704-10.469-1.31 3.925-1.309 6.868c0 3.494 1.417 5.234 4.253 5.234h22.574c4.141 0 6.543-2.068 7.198-6.216l13.413-85.389q.322-1.962-.981-3.599-1.309-1.632-3.27-1.634m-42.695 64.614c-5.563 5.351-12.382 8.017-20.447 8.017-6.329 0-11.4-1.742-15.214-5.234q-5.727-5.225-5.726-14.396c0-8.064 2.725-14.884 8.18-20.446q8.174-8.343 20.284-8.343 9.156 0 15.214 5.398c4.032 3.599 6.052 8.563 6.052 14.888 0 8.069-2.781 14.778-8.343 20.116"
        }
      ),
      /* @__PURE__ */ m(
        "path",
        {
          fill: "#009CDE",
          d: "M540.04 169.85c-8.398-5.774-19.356-8.668-32.879-8.668h-52.02q-6.548.001-7.197 6.214l-21.266 133.48q-.331 1.967.981 3.601c.865 1.092 1.962 1.635 3.271 1.635h26.826q3.925.001 5.235-4.252l5.89-37.949q.325-2.616 2.29-4.254c1.309-1.09 2.943-1.803 4.908-2.13 1.962-.324 3.812-.487 5.562-.487q2.614 0 6.214.327c2.399.218 3.931.324 4.58.324 18.76 0 33.479-5.285 44.168-15.866q16.031-15.865 16.031-44.004c.002-12.867-4.199-22.191-12.594-27.974zm-33.534 53.82q-7.199 4.906-21.592 4.906l-10.47.328 5.562-35.007q.648-3.596 4.252-3.597h5.887q7.195 0 11.454.653c2.831.44 5.562 1.799 8.179 4.089q3.926 3.437 3.926 9.98-.002 13.74-7.198 18.648"
        }
      )
    ]
  }
), _1 = (t) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 578 176", ...t, children: [
  /* @__PURE__ */ M("defs", { children: [
    /* @__PURE__ */ M(
      "linearGradient",
      {
        id: "swish_svg__a",
        x1: "80.815%",
        x2: "59.868%",
        y1: "59.637%",
        y2: "8.15%",
        children: [
          /* @__PURE__ */ m("stop", { offset: "0%", stopColor: "#EF2131" }),
          /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "#FECF2C" })
        ]
      }
    ),
    /* @__PURE__ */ M(
      "linearGradient",
      {
        id: "swish_svg__b",
        x1: "58.818%",
        x2: "9.244%",
        y1: "0%",
        y2: "94.071%",
        children: [
          /* @__PURE__ */ m("stop", { offset: "0%", stopColor: "#FBC52C" }),
          /* @__PURE__ */ m("stop", { offset: "26.392%", stopColor: "#F87130" }),
          /* @__PURE__ */ m("stop", { offset: "56.08%", stopColor: "#EF52E2" }),
          /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "#661EEC" })
        ]
      }
    ),
    /* @__PURE__ */ M(
      "linearGradient",
      {
        id: "swish_svg__c",
        x1: "20.569%",
        x2: "40.597%",
        y1: "41.018%",
        y2: "91.277%",
        children: [
          /* @__PURE__ */ m("stop", { offset: "0%", stopColor: "#78F6D8" }),
          /* @__PURE__ */ m("stop", { offset: "26.571%", stopColor: "#77D1F6" }),
          /* @__PURE__ */ m("stop", { offset: "55.447%", stopColor: "#70A4F3" }),
          /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "#661EEC" })
        ]
      }
    ),
    /* @__PURE__ */ M(
      "linearGradient",
      {
        id: "swish_svg__d",
        x1: "42.44%",
        x2: "91.614%",
        y1: "100%",
        y2: "6.278%",
        children: [
          /* @__PURE__ */ m("stop", { offset: "0%", stopColor: "#536EED" }),
          /* @__PURE__ */ m("stop", { offset: "24.666%", stopColor: "#54C3EC" }),
          /* @__PURE__ */ m("stop", { offset: "56.42%", stopColor: "#64D769" }),
          /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "#FECF2C" })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ M("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ m(
      "path",
      {
        fill: "#4A4A49",
        fillRule: "nonzero",
        d: "M549.059 48.903q0-3.044 1.12-5.708t3.04-4.647a14.2 14.2 0 0 1 4.5-3.124q2.58-1.143 5.54-1.142 3 0 5.62 1.142a14.3 14.3 0 0 1 4.56 3.124q1.94 1.983 3.061 4.647t1.12 5.708q0 3.045-1.12 5.709t-3.06 4.646a14.3 14.3 0 0 1-4.56 3.125q-2.62 1.142-5.62 1.142-2.96 0-5.541-1.142a14.2 14.2 0 0 1-4.5-3.125q-1.92-1.982-3.04-4.646t-1.12-5.709m2.92 0q0 2.524.86 4.687a11.7 11.7 0 0 0 2.38 3.766 11.2 11.2 0 0 0 3.58 2.523q2.06.922 4.46.922 2.44 0 4.52-.922a11.3 11.3 0 0 0 3.62-2.523 11.8 11.8 0 0 0 2.421-3.766q.88-2.163.88-4.687 0-2.523-.88-4.687a11.8 11.8 0 0 0-2.42-3.765 11.3 11.3 0 0 0-3.62-2.524q-2.08-.921-4.52-.921-2.4 0-4.46.921a11.2 11.2 0 0 0-3.581 2.524 11.7 11.7 0 0 0-2.38 3.765q-.86 2.164-.86 4.687m6.4-6.289q0-1.322 1.32-1.322h4.52q2.16 0 3.44 1.242t1.28 3.365q0 .88-.26 1.562a4.4 4.4 0 0 1-.66 1.182q-.4.5-.88.821t-.96.44v.08q.04.041.12.161a.9.9 0 0 1 .16.26q.081.18.24.421l2.08 4.046q.36.68.16 1.102-.2.42-.88.42h-.48q-1.119 0-1.56-.961l-2.32-4.887h-2.48v4.566q0 1.282-1.24 1.282h-.36q-1.24 0-1.24-1.282zm5.24 5.849q1.161 0 1.8-.681.64-.681.64-1.883 0-1.162-.64-1.803-.64-.64-1.76-.64h-2.44v5.007zM447.016 58.04q6.783 0 11.505 1.731t7.382 3.197q2.26 1.2 2.66 3.197c.4 1.997.044 2.752-.665 4.262l-1.33 2.397q-1.197 2.398-3.06 2.797-1.86.4-4.389-.666-2.26-1.065-5.453-2.197-3.192-1.132-7.448-1.132-4.39 0-6.784 1.731t-2.394 4.928q0 2.798 2.46 4.529 2.462 1.731 6.252 3.064 3.79 1.331 8.114 2.863a40.3 40.3 0 0 1 8.113 3.93 20.6 20.6 0 0 1 6.251 6.126q2.46 3.73 2.461 9.457 0 4.53-1.796 8.325t-5.187 6.593q-3.392 2.797-8.18 4.396t-10.64 1.598q-8.247 0-13.9-2.398-5.652-2.397-8.712-4.528-2.261-1.332-2.527-3.33t1.197-4.262l1.596-2.398q1.464-2.13 3.259-2.397 1.796-.267 4.323 1.065 2.394 1.332 6.185 2.997t8.978 1.665q4.389 0 6.916-1.865t2.527-5.061q0-2.797-2.46-4.462t-6.252-3.064a9283 9283 0 0 1-8.113-2.997 43 43 0 0 1-8.114-3.995 20.6 20.6 0 0 1-6.251-6.127q-2.46-3.73-2.46-9.59 0-4.929 2.06-8.791a18.5 18.5 0 0 1 5.587-6.394q3.525-2.53 8.247-3.862t10.042-1.332m-197.709 0q6.784 0 11.506 1.731 4.72 1.732 7.382 3.197 2.26 1.2 2.66 3.197c.4 1.997.044 2.752-.665 4.262l-1.33 2.397q-1.197 2.398-3.06 2.797-1.861.4-4.389-.666-2.26-1.065-5.453-2.197-3.192-1.132-7.449-1.132-4.389 0-6.783 1.731t-2.394 4.928q0 2.798 2.46 4.529t6.252 3.064q3.791 1.331 8.113 2.863a40.3 40.3 0 0 1 8.114 3.93 20.6 20.6 0 0 1 6.251 6.126q2.46 3.73 2.46 9.457 0 4.53-1.795 8.325-1.796 3.795-5.187 6.593t-8.18 4.396-10.64 1.598q-8.247 0-13.9-2.398c-5.653-2.398-6.672-3.107-8.712-4.528q-2.261-1.332-2.527-3.33-.265-1.998 1.197-4.262l1.596-2.398q1.463-2.13 3.259-2.397t4.323 1.065q2.394 1.332 6.184 2.997t8.978 1.665q4.39 0 6.917-1.865t2.527-5.061q0-2.797-2.46-4.462-2.462-1.665-6.252-3.064-3.79-1.398-8.114-2.997a43 43 0 0 1-8.113-3.995 20.6 20.6 0 0 1-6.251-6.127q-2.46-3.73-2.461-9.59 0-4.929 2.062-8.791a18.5 18.5 0 0 1 5.586-6.394q3.525-2.53 8.246-3.862 4.722-1.332 10.042-1.332M491.832 33q5.587 0 5.587 5.594v27.438q0 1.332-.067 2.331-.066 1-.2 1.798a12 12 0 0 0-.132 1.599h.266q1.197-2.399 3.391-4.862t5.188-4.462q2.992-1.998 6.783-3.197 3.79-1.198 8.18-1.198 11.305 0 17.49 6.127 6.186 6.126 6.185 19.713v38.093q0 5.595-5.586 5.595h-5.72q-5.586 0-5.586-5.595v-34.63q0-6.26-2.128-10.057-2.128-3.796-8.512-3.796-4.39 0-8.047 1.732t-6.185 4.728q-2.527 2.997-3.924 7.126t-1.396 8.924v25.973q0 5.595-5.587 5.595h-5.72q-5.585 0-5.585-5.595v-83.38q0-5.594 5.586-5.594zM403.46 59.639q5.454 0 5.454 5.594v56.741q0 5.595-5.454 5.595h-5.852q-5.453 0-5.453-5.595v-56.74q0-5.595 5.453-5.595zm-112.855 0q5.054 0 5.985 4.928l10.907 39.692q.265 1.466.465 2.664.2 1.2.466 2.265.266 1.199.399 2.264h.266q.133-1.065.399-2.264.265-1.065.465-2.265.2-1.198.599-2.664l11.439-39.692q.93-4.794 6.118-4.795h5.054q4.921 0 6.119 4.795l11.305 39.692q.4 1.466.599 2.664.2 1.2.465 2.265.266 1.199.4 2.264h.265q.133-1.065.4-2.264.266-1.065.465-2.265.2-1.198.598-2.664l10.774-39.692q1.197-4.928 6.118-4.928h6.119q3.06 0 4.256 1.732 1.197 1.73.399 4.528l-17.424 57.008q-1.33 4.662-6.251 4.662h-8.912q-5.054 0-6.251-4.795l-10.242-33.965a29 29 0 0 1-.665-2.664 52 52 0 0 0-.532-2.398 25 25 0 0 1-.399-2.264h-.266a89 89 0 0 0-.532 2.264q-.266 1.066-.532 2.398a29 29 0 0 1-.665 2.664l-10.242 33.965q-1.197 4.794-6.118 4.795h-9.177q-4.789 0-6.119-4.662l-17.557-57.008q-.798-2.797.466-4.528 1.263-1.732 4.19-1.732z"
      }
    ),
    /* @__PURE__ */ m(
      "path",
      {
        fill: "url(#swish_svg__a)",
        d: "M0 146.685c35.32 16.893 78.912 8.533 105.246-22.845C136.46 86.648 131.612 31.203 94.418 0L69.692 29.462c29.057 24.377 32.845 67.694 8.46 96.75C58.706 149.378 26.691 157.114 0 146.684",
        transform: "translate(50.006 20.581)"
      }
    ),
    /* @__PURE__ */ m(
      "path",
      {
        fill: "url(#swish_svg__b)",
        d: "M0 146.685c35.32 16.893 78.912 8.533 105.246-22.845a88.5 88.5 0 0 0 8.524-12.067c4.159-25.843-4.987-53.159-26.5-71.207a77 77 0 0 0-17.575-11.1c29.055 24.377 32.84 67.691 8.456 96.745C58.707 149.38 26.693 157.115 0 146.685",
        transform: "translate(50.006 20.581)"
      }
    ),
    /* @__PURE__ */ m(
      "path",
      {
        fill: "url(#swish_svg__c)",
        d: "M125.821 8.56C90.501-8.331 46.91.029 20.575 31.407c-31.214 37.192-26.366 92.637 10.828 123.84l24.727-29.462c-29.058-24.377-32.846-67.694-8.46-96.75C67.114 5.866 99.128-1.869 125.82 8.561"
      }
    ),
    /* @__PURE__ */ m(
      "path",
      {
        fill: "url(#swish_svg__d)",
        d: "M125.821 8.56C90.501-8.331 46.91.029 20.575 31.407a88.5 88.5 0 0 0-8.524 12.067c-4.159 25.843 4.987 53.158 26.5 71.207a77 77 0 0 0 17.575 11.1c-29.054-24.377-32.84-67.691-8.456-96.746C67.114 5.866 99.128-1.869 125.82 8.561"
      }
    )
  ] })
] });
export {
  l1 as AngleDownIcon,
  c1 as AngleLeftIcon,
  u1 as AngleRightIcon,
  h1 as AngleUpIcon,
  m1 as AnimatedLoaderIcon,
  I1 as ApplePayLogo,
  p1 as ArrowIcon,
  F1 as BudbeeLogo,
  g1 as BurgerIcon,
  y1 as CartIcon,
  v1 as CheckIcon,
  O1 as CreditSuisseLogo,
  w1 as CrossIcon,
  j1 as DhlLogo,
  q1 as GooglePayLogo,
  T1 as GridSizeLargeActiveIcon,
  x1 as GridSizeLargeIcon,
  b1 as GridSizeSmallActiveIcon,
  S1 as GridSizeSmallIcon,
  P1 as ImageIcon,
  N1 as InstaboxLogo,
  z1 as KlarnaLogo,
  V1 as MagnifierIcon,
  H1 as MasterCardLogo,
  A1 as MinusIcon,
  U1 as PaypalLogo,
  C1 as PlusIcon,
  D1 as RulerIcon,
  E1 as StatusErrorIcon,
  R1 as StatusInformationIcon,
  L1 as StatusSuccessIcon,
  _1 as SwishLogo,
  M1 as TRYLogo,
  B1 as UserIcon,
  k1 as VoucherIcon
};
//# sourceMappingURL=lib.es.js.map
